{
  "admin": {
    "users": {
      "title": "Users",
      "subtitle": "Gestisci gli utenti della piattaforma, i loro permessi e i DCR associati.",
      "empty": "Nessun utente trovato.",
      "actions": {
        "new": "Nuovo Utente",
        "edit": "Modifica",
        "resetPassword": "Reimposta password",
        "flush": "Aggiorna privilegi"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per email o nome…",
        "level": "Data access level",
        "status": "Stato",
        "permission": "Permesso",
        "dcr": "DCR",
        "all": "Tutti",
        "onlineOnly": "Solo online",
        "reset": "Azzera filtri"
      },
      "levels": {
        "global": "Global",
        "publisher": "User"
      },
      "status": {
        "active": "Attivo",
        "inactive": "Disattivato"
      },
      "table": {
        "email": "Email",
        "name": "Nome",
        "level": "Data access level",
        "status": "Stato",
        "presence": "Presenza"
      },
      "form": {
        "createTitle": "Nuovo Utente",
        "editTitle": "Modifica Utente",
        "id": "ID",
        "name": "Nome",
        "namePlaceholder": "Nome e cognome",
        "email": "Email",
        "emailPlaceholder": "email@esempio.com",
        "emailInvalid": "Email non valida",
        "password": "Password",
        "passwordPlaceholder": "Password iniziale",
        "passwordHint": "Minimo 6 caratteri.",
        "show": "Mostra",
        "hide": "Nascondi",
        "level": "Data access level",
        "sources": "Source (DCR)",
        "sourcesHint": "Tieni premuto Ctrl/Cmd per selezionare più DCR.",
        "mainDcr": "Main DCR",
        "mainDcrPlaceholder": "Seleziona il DCR principale",
        "status": "Stato",
        "permissions": "Permessi",
        "grantAll": "Concedi tutti i permessi",
        "copy": "Copia ID",
        "copied": "Copiato!"
      },
      "messages": {
        "created": "Utente creato.",
        "updated": "Utente aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare gli utenti.",
        "create": "Creazione dell'utente non riuscita.",
        "update": "Aggiornamento dell'utente non riuscito."
      },
      "presence": {
        "online": "Online",
        "offline": "Offline",
        "messages": {
          "flushed": "Aggiornamento privilegi inviato a {{email}}.",
          "notOnline": "{{email}} non risulta più online.",
          "autoFlushed": "Privilegi aggiornati propagati a {{email}} (online)."
        },
        "errors": {
          "flush": "Errore durante l'aggiornamento dei privilegi."
        }
      },
      "resetPassword": {
        "title": "Reimposta Password",
        "user": "Utente",
        "email": {
          "title": "Invia le istruzioni di reset via email",
          "hint": "Viene inviata all'utente un'email con un link per reimpostare la password. Il link è valido per 24 ore.",
          "action": "Invia email",
          "sending": "Invio in corso…"
        },
        "direct": {
          "title": "Imposta direttamente una nuova password",
          "hint": "Imposta subito una nuova password per questo utente. L'utente non viene notificato.",
          "placeholder": "Nuova password",
          "action": "Imposta password",
          "saving": "Salvataggio…",
          "tooShort": "Password troppo corta (minimo 6 caratteri)."
        },
        "messages": {
          "emailSent": "Istruzioni di reset inviate a {{email}}.",
          "passwordSet": "Password aggiornata con successo."
        },
        "errors": {
          "email": "Impossibile inviare le istruzioni di reset.",
          "password": "Impossibile aggiornare la password."
        }
      }
    },
    "cmpCoreVersions": {
      "title": "CMP Core Versions",
      "subtitle": "Gestisci le versioni del core CMP (cmp-core.js) e quante configurazioni deployate usano ciascuna.",
      "empty": "Nessuna versione core trovata.",
      "current": "corrente",
      "actions": {
        "edit": "Modifica"
      },
      "table": {
        "version": "Versione",
        "releasedAt": "Data rilascio",
        "configCount": "Configurazioni che la usano",
        "notes": "Note"
      },
      "edit": {
        "title": "Modifica versione core:",
        "releasedAt": "Data rilascio",
        "notes": "Note",
        "notesPlaceholder": "Note di rilascio per questa versione core…"
      },
      "messages": {
        "updated": "Versione core aggiornata."
      },
      "errors": {
        "load": "Impossibile caricare le versioni core.",
        "update": "Aggiornamento della versione core non riuscito."
      }
    },
    "visionConfigurator": {
      "title": "Vision Configurator",
      "subtitle": "Abilita le entità per Vision e mappa le loro colonne P_* ad audience, personas e goal.",
      "empty": "Nessuna entità trovata.",
      "count": "{{count}} entità",
      "activated": "{{name}} attivata per Vision.",
      "deactivated": "{{name}} disattivata per Vision.",
      "deactivateConfirm": "Disattivare Vision per \"{{name}}\"?\n\nL'entità verrà rimossa da Vision e l'intera configurazione di mapping delle colonne verrà eliminata definitivamente. L'operazione non è reversibile.",
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome o DCR ID…"
      },
      "table": {
        "name": "Nome",
        "dcrId": "DCR ID",
        "active": "Attiva in Vision"
      },
      "actions": {
        "configure": "Configura"
      },
      "errors": {
        "load": "Impossibile caricare le entità.",
        "toggle": "Impossibile aggiornare lo stato dell'entità."
      },
      "mapping": {
        "title": "Mapping colonne",
        "add": "Aggiungi mapping",
        "addTitle": "Aggiungi mapping colonna",
        "editTitle": "Modifica mapping colonna",
        "empty": "Nessun mapping colonna presente.",
        "lockedCol": "Locked",
        "locked": "Locked",
        "unlocked": "Sbloccato",
        "unlockedSession": "Sbloccato (sessione)",
        "sessionUnlockHint": "Sblocca per modificare — temporaneo, non salvato. Lo stato di lock salvato si cambia dal form di modifica.",
        "lockedEditHint": "Bloccato. Sblocca prima questa riga per modificarla.",
        "lockedDeleteHint": "Bloccato. Sbloccalo davvero (form di modifica → Locked off) prima di eliminare.",
        "lockedFlagHint": "Lock persistente. Se attivo, la riga è protetta dalle modifiche in lista finché non viene sbloccata.",
        "column": "Colonna",
        "columnPlaceholder": "Seleziona una colonna P_*",
        "columnRequired": "Seleziona una colonna.",
        "objectType": "Tipo oggetto",
        "object": "Oggetto",
        "objectPlaceholder": "— seleziona {{type}} —",
        "objectHint": "Raggruppati per owner. Selezionando un oggetto il nome visualizzato viene compilato automaticamente.",
        "objectName": "Nome oggetto",
        "objectId": "ID oggetto",
        "objectIdPlaceholder": "ID oggetto (opzionale)",
        "displayName": "Nome visualizzato (in Vision)",
        "displayNamePlaceholder": "Nome mostrato in Vision",
        "displayNameRequired": "Inserisci un nome visualizzato.",
        "delete": "Elimina",
        "deleteConfirm": "Eliminare il mapping per {{column}} ({{object}})?",
        "created": "Mapping colonna aggiunto.",
        "updated": "Mapping colonna aggiornato.",
        "deleted": "Mapping colonna eliminato.",
        "loadError": "Impossibile caricare i mapping.",
        "saveError": "Salvataggio non riuscito.",
        "deleteError": "Eliminazione non riuscita."
      }
    },
    "destinations": {
      "title": "Destinations",
      "subtitle": "Gestisci le destination di attivazione: connettori, ownership multi-DCR e parametri di connessione.",
      "empty": "Nessuna destination trovata.",
      "count": "{{count}} destination",
      "sandbox": "Sandbox",
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome, tipo, connettore o owner…",
        "onlyChartSelected": "Solo selezionate nel grafico ({{count}})",
        "onlyChartSelectedHint": "Mostra solo le destinazioni selezionate nel grafico sopra",
        "onlyChartSelectedEmpty": "Seleziona destinazioni nel grafico sopra per attivare questo filtro"
      },
      "table": {
        "connectionStatus": "Stato connessione",
        "id": "ID",
        "name": "Nome",
        "description": "Descrizione",
        "type": "Tipo",
        "connector": "Connettore",
        "owners": "DCRs",
        "owner": "Owner",
        "idType": "ID Type",
        "exportId": "Export ID",
        "status": "Stato",
        "sandbox": "Sandbox",
        "actions": "Azioni"
      },
      "status": {
        "active": "Attiva",
        "inactive": "Inattiva"
      },
      "conn": {
        "ok": "Connessione OK",
        "error": "Connessione fallita",
        "pending": "Testa la connessione per aggiornare lo stato"
      },
      "actions": {
        "new": "Nuova destination",
        "edit": "Modifica connessione",
        "test": "Testa connessione",
        "testing": "Test in corso…",
        "pushDetails": "Dettagli push file",
        "activate": "Attiva",
        "deactivate": "Disattiva",
        "delete": "Elimina",
        "deleteConfirm": "Eliminare la destination \"{{name}}\"? L'operazione non è reversibile."
      },
      "messages": {
        "created": "Destination creata.",
        "updated": "Destination aggiornata.",
        "deleted": "Destination \"{{name}}\" eliminata.",
        "activated": "{{name}} attivata.",
        "deactivated": "{{name}} disattivata.",
        "testOk": "Connessione a {{name}} riuscita."
      },
      "errors": {
        "load": "Impossibile caricare le destination.",
        "save": "Impossibile salvare la destination.",
        "delete": "Impossibile eliminare la destination.",
        "status": "Impossibile aggiornare lo stato della destination.",
        "test": "Test di connessione fallito.",
        "typeRequired": "Seleziona un tipo di destination.",
        "ownerRequired": "Aggiungi almeno un DCR owner."
      },
      "form": {
        "createTitle": "Nuova destination",
        "editTitle": "Modifica destination",
        "description": "Configura connettore, ownership e parametri di connessione.",
        "name": "Nome",
        "namePlaceholder": "Nome della destination",
        "nameRequired": "Inserisci un nome.",
        "type": "Tipo destination",
        "typePlaceholder": "Seleziona un tipo di destination",
        "connector": "Connettore",
        "exportId": "Tipo Export ID",
        "select": "Seleziona…",
        "owner": "Owner (DCR)",
        "ownerPlaceholder": "Seleziona il DCR owner",
        "visibility": "Visibilità — altre DCR",
        "visibilityHint": "DCR abilitate a vedere/usare questa destination (oltre all'owner). Solo un admin con scope globale può modificarlo.",
        "owners": "DCR owner",
        "ownerSelect": "Seleziona un DCR…",
        "addOwner": "Aggiungi",
        "primaryOwner": "primario",
        "ownersHint": "Il primo DCR è l'owner primario. Solo un admin con scope globale può modificare l'ownership.",
        "sandbox": "Destination sandbox",
        "connectionParams": "Parametri di connessione",
        "testConnection": "Testa connessione",
        "selectTypeFirst": "Seleziona un tipo di destination per configurarne la connessione.",
        "paramsPreserved": "I parametri di connessione esistenti vengono mantenuti. Abilita la modifica per sostituirli.",
        "modifyParams": "Modifica parametri di connessione",
        "keepExistingParams": "Mantieni i parametri esistenti",
        "noParamsForConnector": "Questo connettore non ha parametri modificabili.",
        "showParams": "Mostra parametri di connessione salvati",
        "savedParams": "Parametri di connessione salvati",
        "showParamsError": "Impossibile decifrare i parametri di connessione salvati.",
        "create": "Crea"
      },
      "pushDetails": {
        "title": "Dettagli push file",
        "date": "Data",
        "exportPath": "Export path",
        "destinationPath": "Destination path",
        "status": "Stato",
        "description": "Descrizione",
        "empty": "Nessun job di push per questo giorno.",
        "error": "Impossibile caricare i dettagli di push."
      },
      "chart": {
        "title": "Job di push",
        "subtitle": "File caricati, in attesa e in errore per giorno",
        "range": "Intervallo",
        "lastDays": "Ultimi {{days}}g",
        "destinations": "Destinazioni selezionate",
        "searchDestinations": "Cerca destinazioni…",
        "noDestinations": "Nessuna destinazione",
        "clearSelection": "Azzera selezione",
        "onlyErrors": "Solo errori",
        "showAll": "Mostra tutti",
        "noData": "Nessun job di push in questo intervallo.",
        "error": "Impossibile caricare i job di push.",
        "dayBreakdown": "Dettaglio — {{date}}",
        "destination": "Destinazione",
        "series": {
          "uploaded": "Caricati",
          "pending": "In attesa",
          "error": "Errori"
        }
      }
    },
    "activations": {
      "title": "Activations",
      "subtitle": "Monitora le attivazioni delle audience e i job di push verso le destination.",
      "empty": "Nessun dato.",
      "tabs": {
        "activations": "Attivazioni",
        "jobs": "Job"
      },
      "toolbar": {
        "searchPlaceholder": "Cerca audience, destination, entity…",
        "count": "{{count}} attivazioni",
        "includeInactive": "Includi destination inattive/eliminate"
      },
      "filters": {
        "byActivationStatus": "Per stato attivazione",
        "byAudienceStatus": "Per stato audience"
      },
      "status": {
        "all": "Tutte",
        "active": "Attive",
        "stopped": "Ferme"
      },
      "audienceStatus": {
        "all": "Tutte",
        "active": "Attiva",
        "stopped": "Ferma",
        "ended": "Terminata",
        "draft": "Bozza",
        "error": "Errore"
      },
      "groupBy": {
        "label": "Raggruppa per",
        "destination": "Destination",
        "entity": "Entity",
        "audience": "Audience",
        "clear": "Rimuovi raggruppamento"
      },
      "table": {
        "destination": "Destination",
        "entity": "Entity",
        "audience": "Audience",
        "status": "Stato",
        "volume": "Volume",
        "lastPush": "Ultimo push",
        "externalSegmentId": "External segment ID"
      },
      "detail": {
        "audienceId": "Audience ID",
        "destinationId": "Destination ID",
        "entityId": "Entity ID",
        "audienceStatus": "Stato audience",
        "notOperating": "non operativa",
        "createdAt": "Creata il",
        "updatedAt": "Aggiornata il",
        "nextExecution": "Prossima esecuzione",
        "startDate": "Data inizio",
        "endDate": "Data fine"
      },
      "statusMenu": {
        "title": "Cambia stato",
        "setActive": "Imposta attiva",
        "setStopped": "Imposta ferma"
      },
      "messages": {
        "statusUpdated": "Stato attivazione aggiornato."
      },
      "errors": {
        "loadActivations": "Caricamento delle attivazioni non riuscito.",
        "statusUpdate": "Impossibile aggiornare lo stato dell'attivazione.",
        "loadJobs": "Caricamento dei job non riuscito.",
        "loadJobDetails": "Caricamento dei dettagli del job non riuscito."
      },
      "jobs": {
        "count": "{{count}} riepiloghi job",
        "lastDays": "(ultimi 7 giorni)",
        "allDestinations": "Tutte le destination",
        "from": "Da",
        "to": "a",
        "resetRange": "Reimposta agli ultimi 7 giorni",
        "uploadingCount": "{{count}} in caricamento",
        "errorsCount": "{{count}} errori",
        "noMatch": "Nessuna destination corrisponde al filtro.",
        "stats": {
          "uploaded": "Caricati",
          "uploading": "In caricamento",
          "queued": "In coda",
          "errors": "Errori"
        },
        "detailTable": {
          "description": "Descrizione",
          "exportPath": "Export path",
          "destinationFile": "File destination",
          "lastUpdate": "Ultimo aggiornamento"
        }
      }
    },
    "entities": {
      "title": "Entities",
      "subtitle": "Gestisci le entity (DCR / publisher) della piattaforma.",
      "empty": "Nessuna entity trovata.",
      "actions": {
        "new": "Nuova Entity",
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome o ID…"
      },
      "table": {
        "name": "Nome",
        "status": "Stato",
        "sandbox": "Sandbox"
      },
      "status": {
        "active": "Attiva",
        "inactive": "Disattiva"
      },
      "sandbox": {
        "yes": "Sì",
        "no": "No"
      },
      "form": {
        "createTitle": "Nuova Entity",
        "editTitle": "Modifica Entity",
        "id": "ID",
        "name": "Nome",
        "namePlaceholder": "Nome dell'entity",
        "nameTaken": "Nome già in uso. Suggerito:",
        "status": "Stato",
        "sandbox": "Sandbox",
        "copy": "Copia ID",
        "copied": "Copiato!"
      },
      "messages": {
        "created": "Entity creata.",
        "updated": "Entity aggiornata."
      },
      "errors": {
        "load": "Impossibile caricare le entity.",
        "create": "Creazione dell'entity non riuscita.",
        "update": "Aggiornamento dell'entity non riuscito."
      }
    },
    "apiLog": {
      "title": "API Log",
      "subtitle": "Log degli errori delle API (sola lettura).",
      "empty": "Nessuna voce di log trovata.",
      "actions": {
        "refresh": "Aggiorna"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per API, tipo o descrizione…"
      },
      "table": {
        "time": "Data/ora",
        "api": "API",
        "messageType": "Tipo",
        "messageDescription": "Descrizione",
        "env": "Env"
      },
      "errors": {
        "load": "Impossibile caricare il log."
      }
    },
    "overview": {
      "title": "Overview",
      "subtitle": "Dati identità cross-entità (solo in ambito dati globale).",
      "filters": {
        "active": "Filtri attivi",
        "tncidPlusOnly": "Solo utenti TNCID+",
        "hasFirstVisit": "Tracciati da più di 30 giorni",
        "hasEmail": "Con email",
        "hasMaid": "Con MAID",
        "hasIpLocation": "Con localizzazione IP",
        "hasCookieAdform": "Con cookie Adform",
        "hasCookieTtd": "Con cookie TTD",
        "hasCookieAudiencerate": "Con cookie Audience Rate",
        "hasZeotap": "Con Zeotap",
        "country": "Paese",
        "gender": "Genere",
        "age": "Fascia d'età",
        "all": "Tutti",
        "male": "Maschio",
        "female": "Femmina",
        "unknown": "Sconosciuto"
      },
      "range": {
        "days": "{{count}} giorni"
      },
      "tabs": {
        "cards": "Schede",
        "table": "Tabella"
      },
      "table": {
        "section": "Sezione",
        "metric": "Metrica",
        "tncids": "TNCID",
        "downloadCsv": "Scarica CSV"
      },
      "sections": {
        "identity": "Identità",
        "matchRates": "Tassi di match",
        "gender": "Genere",
        "age": "Età"
      },
      "metrics": {
        "total": "TNCID",
        "returning": "Tracciati da più di 30 giorni",
        "italy": "Italia",
        "email": "Email",
        "maid": "MAID",
        "ipLandline": "IP landline",
        "adform": "Cookie Adform",
        "ttd": "Cookie TTD",
        "audRate": "Cookie Audience Rate",
        "zeotap": "Cookie Zeotap",
        "male": "Maschio",
        "female": "Femmina",
        "unknown": "Sconosciuto",
        "age1824": "18-24",
        "age2534": "25-34",
        "age3544": "35-44",
        "age4554": "45-54",
        "age5564": "55-64",
        "age65p": "65+",
        "tncPlus": "TNCID+",
        "pctOfTotal": "% su TNCID",
        "pctOfTotalPlus": "% su TNCID+"
      },
      "errors": {
        "load": "Impossibile caricare l'overview.",
        "retry": "Riprova"
      }
    },
    "dcrGroups": {
      "title": "Entity Groups",
      "subtitle": "Gestisci i gruppi di entity (DCR/publisher) e i loro membri.",
      "empty": "Nessun gruppo trovato.",
      "allDcrs": "Tutte le entity",
      "noOwner": "Nessun owner",
      "actions": {
        "new": "Nuovo Entity Group",
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome, tipo o owner…"
      },
      "table": {
        "name": "Nome",
        "type": "Tipo",
        "owner": "Owner (Entity)",
        "members": "Membri"
      },
      "types": {
        "audience": "Audience",
        "custom": "Custom List",
        "firstParty": "First Party"
      },
      "form": {
        "createTitle": "Nuovo Entity Group",
        "editTitle": "Modifica Entity Group",
        "name": "Nome",
        "namePlaceholder": "Nome del gruppo",
        "type": "Tipo",
        "owner": "Owner (Entity)",
        "ownerPlaceholder": "Seleziona l'entity proprietaria",
        "members": "Membri (Entity)",
        "addMember": "Aggiungi Entity…",
        "add": "Aggiungi",
        "id": "ID",
        "status": "Stato",
        "copy": "Copia ID",
        "copied": "Copiato!"
      },
      "status": {
        "active": "Attivo",
        "inactive": "Disattivo"
      },
      "messages": {
        "created": "Gruppo creato.",
        "updated": "Gruppo aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare i gruppi.",
        "create": "Creazione del gruppo non riuscita.",
        "update": "Aggiornamento del gruppo non riuscito."
      }
    },
    "destinationTypes": {
      "title": "Destination Types",
      "subtitle": "Configura, per ogni tipo di destinazione, i permessi di servizio per DCR e gli Export ID Types associati.",
      "empty": "Nessun destination type trovato.",
      "allDcrs": "Tutti i DCR",
      "actions": {
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome, descrizione o connettore…"
      },
      "table": {
        "name": "Nome",
        "description": "Descrizione",
        "connector": "Connettore",
        "activationType": "Tipo attivazione",
        "assisted": "Assisted Service",
        "self": "Self Service",
        "exportIds": "Export ID Types"
      },
      "form": {
        "title": "Modifica Destination Type",
        "add": "Aggiungi",
        "addDcr": "Aggiungi DCR…",
        "addExportId": "Aggiungi Export ID Type…"
      },
      "messages": {
        "updated": "Destination type aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare i destination types.",
        "update": "Aggiornamento del destination type non riuscito."
      }
    },
    "providers": {
      "title": "Providers",
      "subtitle": "Gestisci i provider (fornitori di dati) e la loro associazione ai DCR.",
      "empty": "Nessun provider trovato.",
      "actions": {
        "new": "Nuovo Provider",
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome, sito o DCR…",
        "status": "Stato",
        "statusAll": "Tutti"
      },
      "status": {
        "active": "Attivo",
        "inactive": "Disattivo"
      },
      "table": {
        "dcr": "DCR",
        "name": "Nome",
        "site": "Sito",
        "status": "Stato"
      },
      "form": {
        "createTitle": "Nuovo Provider",
        "editTitle": "Modifica Provider",
        "id": "ID",
        "name": "Nome",
        "namePlaceholder": "Nome del provider",
        "site": "Sito",
        "sitePlaceholder": "es. example.com",
        "publisher": "DCR (Publisher)",
        "publisherPlaceholder": "Seleziona un DCR",
        "status": "Stato",
        "usePublisherId": "Abilita come network di siti (verranno generati automaticamente i singoli ProviderID)",
        "usePublisherIdHint": "Il provider adotterà l'ID del DCR selezionato (caso publisher = provider). Consentito solo se quell'ID non è già usato da un altro provider."
      },
      "messages": {
        "created": "Provider creato.",
        "updated": "Provider aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare i provider.",
        "create": "Creazione del provider non riuscita.",
        "update": "Aggiornamento del provider non riuscito.",
        "publisherIdTaken": "Impossibile usare questo PublisherID: esiste già un provider con questo ID."
      }
    },
    "vendors": {
      "title": "Vendors",
      "subtitle": "Gestisci i vendor (fornitori) disponibili per gli Export ID Types.",
      "empty": "Nessun vendor trovato.",
      "actions": {
        "new": "Nuovo Vendor",
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome o ID…"
      },
      "table": {
        "name": "Nome",
        "status": "Stato"
      },
      "status": {
        "enabled": "Attivo",
        "disabled": "Disattivo"
      },
      "form": {
        "createTitle": "Nuovo Vendor",
        "editTitle": "Modifica Vendor",
        "id": "ID",
        "name": "Nome",
        "namePlaceholder": "Nome del vendor",
        "status": "Stato"
      },
      "messages": {
        "created": "Vendor creato.",
        "updated": "Vendor aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare i vendor.",
        "create": "Creazione del vendor non riuscita.",
        "update": "Aggiornamento del vendor non riuscito."
      }
    },
    "exportIdTypes": {
      "title": "Export ID Types",
      "subtitle": "Gestisci i tipi di ID di export e la loro associazione ai vendor.",
      "empty": "Nessun Export ID Type trovato.",
      "actions": {
        "new": "Nuovo Export ID Type",
        "edit": "Modifica"
      },
      "filters": {
        "search": "Cerca",
        "searchPlaceholder": "Cerca per nome, tipo o vendor…"
      },
      "table": {
        "name": "Nome",
        "exportIdType": "Export ID Type",
        "partyType": "Party Type",
        "vendor": "Vendor",
        "ttl": "TTL"
      },
      "form": {
        "createTitle": "Nuovo Export ID Type",
        "editTitle": "Modifica Export ID Type",
        "name": "Nome",
        "namePlaceholder": "Nome descrittivo",
        "exportIdType": "Export ID Type",
        "exportIdTypePlaceholder": "es. email_sha256",
        "exportIdTypeLocked": "L'Export ID Type identifica il record e non è modificabile.",
        "identityLocked": "Nome, Export ID Type e Party Type identificano il record: in modifica puoi cambiare solo Vendor e TTL.",
        "partyType": "Party Type",
        "partyTypePlaceholder": "Seleziona un party type",
        "vendor": "Vendor",
        "vendorNone": "Nessuno",
        "ttl": "TTL (opzionale)",
        "ttlPlaceholder": "Time to live"
      },
      "messages": {
        "created": "Export ID Type creato.",
        "updated": "Export ID Type aggiornato."
      },
      "errors": {
        "load": "Impossibile caricare gli Export ID Types.",
        "create": "Creazione dell'Export ID Type non riuscita.",
        "update": "Aggiornamento dell'Export ID Type non riuscito."
      }
    }
  },
  "notifyBroadcast": {
    "title": "Invia notifica",
    "subtitle": "Invia un messaggio agli admin, a un publisher o a un singolo utente.",
    "target": "Destinatario",
    "targets": {
      "admin": "Admin",
      "entity": "Publisher",
      "user": "Utente"
    },
    "selectPublisher": "Seleziona publisher",
    "selectUser": "Seleziona utente",
    "searchPlaceholder": "Cerca…",
    "permAreas": {
      "analytics": "Analytics",
      "vision": "Vision",
      "reach": "Reach",
      "scripts": "Scripts",
      "cmp": "CMP",
      "admin_dashboard": "Admin dashboard",
      "special_features": "Funzioni speciali"
    },
    "permFilter": {
      "title": "Filtra per permesso",
      "add": "Aggiungi filtro permesso…",
      "all": "Tutti",
      "leaves": {
        "reach": {
          "audience": "Audience",
          "custom_import": "Import personalizzato",
          "goal": "Goal",
          "reporting": "Reportistica"
        },
        "special_features": {
          "can_impersonate": "Impersonazione",
          "experiments": "Esperimenti",
          "can_broadcast": "Invio notifiche"
        }
      }
    },
    "loading": "Caricamento…",
    "noResults": "Nessun risultato",
    "messageType": "Tipo",
    "types": {
      "info": "Info",
      "success": "Successo",
      "warning": "Avviso",
      "error": "Errore"
    },
    "message": "Messaggio",
    "messagePlaceholder": "Scrivi il messaggio…",
    "alsoEmail": "Invia anche via email",
    "cancel": "Annulla",
    "send": "Invia",
    "sending": "Invio…",
    "sent": "Notifica inviata",
    "failed": "Invio notifica fallito"
  },
  "experimentalFeatures": {
    "title": "Funzioni sperimentali",
    "subtitle": "Attiva funzioni in fase di sviluppo. Visibile solo agli admin.",
    "empty": "Nessuna funzione sperimentale disponibile al momento.",
    "menuLabel": "Funzioni sperimentali",
    "markerTooltip": "Funzione sperimentale",
    "features": {
      "audienceOwnerFilter": {
        "label": "Filtro proprietario audience",
        "description": "Mostra il filtro dropdown per proprietario nella lista audience di Reach."
      },
      "audienceExtractionDateFilter": {
        "label": "Filtro data di estrazione audience",
        "description": "Mostra nella lista audience di Reach un calendario per vedere le audience estratte in un giorno passato o previste oggi e nei giorni futuri (±31 giorni)."
      },
      "accordionProductsMenu": {
        "label": "Menu prodotti ad accordion",
        "description": "Mostra il menu dei prodotti come accordion: ogni prodotto si espande mostrando i suoi sotto-menu, uno alla volta."
      },
      "audienceInsights": {
        "label": "Insight audience",
        "description": "Mostra le insight audience avanzate: grafici estrazioni/volumi/push e le tab Additional Info (richiede il permesso admin dashboard)."
      }
    }
  },
  "sessionExpired": {
    "title": "Sessione scaduta",
    "message": "La tua sessione è scaduta. Effettua nuovamente l'accesso per continuare.",
    "action": "Vai al login",
    "updatedTitle": "Aggiornamento applicato",
    "updatedMessage": "L'applicazione è stata aggiornata e la tua sessione non è più valida. Effettua nuovamente l'accesso per continuare."
  },
  "common": {
    "clearSearch": "Cancella ricerca",
    "loading": "Caricamento dati...",
    "noData": "Nessun dato trovato",
    "table": "TABELLA",
    "charts": "GRAFICI",
    "showTableView": "Mostra tabella",
    "showChartsView": "Torna ai grafici",
    "png": "PNG",
    "xls": "XLS",
    "help": "AIUTO",
    "retry": "Riprova",
    "refresh": "Aggiorna",
    "allEntities": "Tutte le Entity",
    "cancel": "Annulla",
    "close": "Chiudi",
    "show": "Mostra",
    "hide": "Nascondi",
    "copy": "Copia",
    "copied": "Copiato!",
    "edit": "Modifica",
    "save": "Salva",
    "active": "Attivo",
    "inactive": "Inattivo",
    "saving": "Salvataggio…",
    "processing": "Elaborazione...",
    "pagination": {
      "rowsPerPage": "Righe per pagina",
      "of": "di"
    },
    "page": "Pagina {{current}} di {{total}}",
    "rowsPerPage": "Righe per pagina",
    "entitySelectionWarning": "Seleziona una Entity specifica per vedere i dati di questa pagina: i report sono per singola Entity.",
    "yes": "Sì",
    "no": "No"
  },
  "home": {
    "heroTitle": "Con <span class=\"hero-highlight\">TNC Engine</span> arricchisci la conoscenza degli utenti, crei audience con il supporto dell'AI e le attivi direttamente, mantenendo il pieno controllo dei tuoi dati",
    "newsSubtitle": "Non perderti le nostre novità, interviste e casi di successo sul nostro sito",
    "branded": {
      "title": "Scopri le novità di TNC Engine",
      "excerpt": "Articoli, interviste e casi di successo sulla nostra piattaforma per la gestione dei dati di prima parte.",
      "cta": "Vai al portfolio"
    },
    "readMore": "Leggi tutto",
    "article1": {
      "title": "Come una media platform può massimizzare il valore delle audience",
      "excerpt": "Con Moreno Schioppa, Head of Trafficking di Piemme S.p.A., abbiamo analizzato come le media platform possono sfruttare i dati delle audience."
    },
    "article2": {
      "title": "Come sfruttare una migliore gestione dei dati di prima parte",
      "excerpt": "Una delle sfide più complesse per i brand strutturati: far dialogare tecnologie diverse per massimizzare il valore dei dati di prima parte."
    }
  },
  "destinations": {
    "title": "Destinazioni",
    "subtitle": "Configura gli endpoint di attivazione e aggiorna le credenziali.",
    "activation": {
      "title": "Attiva destinazione",
      "subtitle": "Seleziona una destinazione da attivare per questa audience",
      "destinationsLabel": "Destinazioni",
      "destinationsHint": "Scegli una o più destinazioni su cui esportare questa audience.",
      "loadingDestinations": "Caricamento destinazioni disponibili…",
      "noAvailableDestinations": "Non ci sono destinazioni configurate per questo canale.",
      "selectDestinationError": "Seleziona almeno una destinazione per continuare.",
      "error": "Impossibile attivare le destinazioni selezionate.",
      "noDestinationsForType": "Nessuna destinazione configurata per questo tipo.",
      "noTypes": "Nessun tipo di destinazione disponibile.",
      "noDestinationsAvailable": "Richiedi nuove destinazioni agli amministratori",
      "requestHint": "Invia una richiesta per ricevere assistenza dall'amministratore.",
      "requestHintAssistedService": "La tua richiesta sarà presa in carico da un amministratore.",
      "selectEntityForActivation": "Questa destinazione richiede un'entity. Selezionane una per continuare.",
      "selectEntityPlaceholder": "Seleziona un'entity",
      "requestButton": "Richiedi attivazione",
      "externalSegmentIdOptional": "ID segmento esterno (opzionale)",
      "requestSent": "Richiesta di attivazione inviata correttamente.",
      "requestError": "Impossibile inviare la richiesta di attivazione.",
      "editTitle": "Modifica attivazione: {{name}}",
      "editSuccess": "Attivazione {{name}} aggiornata",
      "editError": "Impossibile aggiornare l'attivazione.",
      "saveButton": "Salva modifiche",
      "noEditableFields": "Questo tipo di attivazione non ha campi modificabili.",
      "alerts": {
        "GAM": "Prima di attivare l'export assicurarsi che siano passate almeno 24 ore dalla creazione del segmento su GAM."
      }
    },
    "fields": {
      "externalSegmentId": "ID Segmento Esterno",
      "pubmaticAudienceId": "Pubmatic Audience ID",
      "audienceName": "Nome Audience",
      "description": "Descrizione",
      "country": "Paese",
      "price": "Prezzo (CPM)",
      "externalSegmentParentId": "ID Segmento Esterno Padre",
      "externalSegmentParentIdDefault": "— Usa il default della destination —",
      "refreshTaxonomy": "Aggiorna",
      "taxonomyLoading": "Caricamento tassonomia TTD…",
      "taxonomyEmpty": "Nessun nodo di tassonomia in cache per questa destination. Prova ad aggiornare.",
      "cpmRateAmount": "CPM Rate",
      "cpmCurrency": "Valuta CPM",
      "percentOfMediaCost": "% del Media Cost",
      "rateLevel": "Rate Level",
      "partnerId": "Partner ID",
      "advertiserId": "Advertiser ID",
      "buyable": "Acquistabile",
      "activationNote": "Nota interna",
      "excludeControlGroup": "Escludi gruppo di controllo (solo admin)",
      "extendToFamily": "Estendi al nucleo familiare (solo admin)",
      "extendToFamilyNotApplied": "Non applicato a {{names}}: esporta IP landline, che coincide con l'IP di casa del nucleo.",
      "extendToFamilyUnavailable": "Non disponibile per destinazioni che esportano IP landline: coincide con l'IP di casa del nucleo.",
      "region": "Regione",
      "segmentType": "Tipo Segmento",
      "mergeMode": "Merge Mode",
      "trackingTagName": "Nome Tracking Tag",
      "externalAudienceId": "ID Audience Esterno",
      "entity": "Entity",
      "externalAudienceName": "Nome Audience Esterno",
      "ownerId": "Owner ID",
      "ttl": "TTL (giorni)",
      "segmentName": "Nome Segmento",
      "cpmPrice": "Prezzo CPM",
      "countries": "Paesi",
      "zeotapSegmentId": "Zeotap Segment ID",
      "zeotapDestinationId": "ID Destinazione Zeotap",
      "dataPrice": "Prezzo",
      "currency": "Valuta",
      "zeotapAccountType": "Invia a",
      "accountName": "Nome account",
      "accountId": "Account ID",
      "advertiserName": "Nome Advertiser",
      "accountType": "Account",
      "accountTypePlaceholder": "Seleziona il tipo di account",
      "companyId": "Company ID",
      "companyIdPlaceholder": "Recuperabile dall'interfaccia Infosum o contattando il supporto"
    },
    "activateButton": "Attiva destinazione",
    "gam": {
      "warning": "Prima di procedere con l'export, crea l'audience in Google Ad Manager. Procedi con l'export solo per audience create in Google Ad Manager da almeno 24 ore.",
      "audienceId": "Audience ID GAM"
    },
    "tradeDesk": {
      "advertiserId": "Advertiser ID"
    },
    "dv360": {
      "accountType": "Google Display & Video 360 Account",
      "clientId": "Client ID",
      "accountTypePlaceholder": "Seleziona il tipo di account",
      "accountTypes": {
        "advertiser": "Account DV360 Advertiser",
        "partner": "Account DV360 Partner"
      }
    },
    "adform": {
      "country": "Paese",
      "accountName": "Nome account",
      "countryPlaceholder": "Seleziona il paese"
    },
    "pubmatic": {
      "accountType": "Account",
      "accountId": "Account ID",
      "accountTypePlaceholder": "Seleziona il tipo di account",
      "accountTypes": {
        "publisher": "Publisher",
        "advertiser": "Advertiser"
      }
    },
    "actions": {
      "new": "+ Destinazione",
      "edit": "Modifica",
      "delete": "Elimina",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "deleteConfirm": "Eliminare la destinazione \"{{name}}\"?",
      "cancel": "Annulla",
      "save": "Salva",
      "saving": "Salvataggio…",
      "close": "Chiudi",
      "menuTitle": "Azioni rapide"
    },
    "filters": {
      "search": "Cerca destinazioni",
      "status": {
        "active": "Attiva",
        "inactive": "Inattiva"
      },
      "selected": "Destinazioni selezionate",
      "selectedHint": "Scegli una o più destinazioni per filtrare la lista.",
      "searchPlaceholder": "Cerca destinazioni…",
      "noResults": "Nessuna destinazione trovata"
    },
    "states": {
      "loading": "Caricamento destinazioni…",
      "empty": "Nessuna destinazione disponibile.",
      "saving": "Salvataggio…"
    },
    "toolbar": {
      "total": "{{count}} destinazioni"
    },
    "status": {
      "active": "Attiva",
      "inactive": "Inattiva"
    },
    "table": {
      "connection": "Connessione",
      "name": "Nome",
      "type": "Tipo",
      "activation": "Attivazione",
      "owner": "Proprietario",
      "status": "Stato",
      "active": "Attiva",
      "actions": "Azioni"
    },
    "form": {
      "createTitle": "Crea destinazione",
      "editTitle": "Modifica destinazione",
      "description": "Imposta i metadati principali e inserisci le credenziali del connettore.",
      "name": "Nome",
      "destinationType": "Tipo destinazione",
      "select": "Seleziona",
      "activation": "Attivazione: {{value}}",
      "connector": "Connettore: {{value}}",
      "typeLabel": "Tipo destinazione",
      "activationLabel": "Tipo di attivazione",
      "connectorLabel": "Tipo di connettore",
      "connectionParams": "Parametri di connessione (JSON)",
      "connectionHint": "Inserisci JSON valido con le credenziali di connessione",
      "connectionPlaceholder": "{\"JsonCredentials\": \"…\"}",
      "connectionFieldsHint": "Compila i parametri richiesti dal connettore selezionato.",
      "uploadJson": "Carica file credenziali",
      "selectTypeHint": "Seleziona un tipo di destinazione per configurare i parametri di connessione.",
      "active": "Destinazione attiva"
    },
    "messages": {
      "saved": "Destinazione salvata correttamente.",
      "deleted": "Destinazione eliminata.",
      "activated": "Destinazione \"{{name}}\" attivata.",
      "deactivated": "Destinazione \"{{name}}\" sospesa.",
      "loadError": "Impossibile caricare le destinazioni."
    },
    "errors": {
      "load": "Impossibile caricare le destinazioni.",
      "save": "Impossibile salvare la destinazione.",
      "delete": "Impossibile eliminare la destinazione.",
      "status": "Impossibile aggiornare lo stato della destinazione.",
      "typeRequired": "Seleziona un tipo destinazione.",
      "invalidJson": "I parametri devono essere un JSON valido.",
      "ownerRequired": "Seleziona il proprietario della destinazione prima di salvare."
    },
    "pagination": {
      "rowsPerPage": "Righe per pagina",
      "page": "Pagina {{current}} di {{total}}"
    }
  },
  "sidebar": {
    "logoAlt": "Logo The NewCo",
    "user": {
      "admin": "Amministratore",
      "standard": "Utente"
    },
    "userMenu": {
      "title": "Menu Utente"
    },
    "productSelector": {
      "title": "Prodotto"
    },
    "dcr": {
      "select": "Seleziona Entity",
      "searchPlaceholder": "Cerca Entity...",
      "empty": "Nessuna Entity trovata",
      "globalScope": "Global Data Scope",
      "title": "Entity"
    },
    "impersonate": {
      "myself": "— me stesso —",
      "title": "Impersona utente"
    },
    "changePassword": "Cambia password",
    "logout": "Esci",
    "documentation": "Documentazione",
    "nav": {
      "public": "INSIGHTS",
      "personas": "PERSONAS",
      "audience": "AUDIENCE",
      "comparison": "COMPARAZIONE AUDIENCE",
      "customImports": "FILE CARICATI",
      "destinations": "DESTINAZIONI",
      "goals": "REGOLE CUSTOM",
      "reporting": "REPORTING",
      "reportsProvider": "RICAVI (DATA PROVIDER)",
      "reportsConsumer": "COSTI (DATA CONSUMER)",
      "analyticsOverview": "PANORAMICA",
      "realtime": "REALTIME",
      "trackingScripts": "CONFIGURAZIONI",
      "cmp": "CONFIGURAZIONI",
      "config": "CONFIG",
      "exportIdTypes": "EXPORT ID TYPES",
      "vendors": "VENDORS",
      "providers": "PROVIDERS",
      "destinationTypes": "DESTINATION TYPES",
      "dcrGroups": "ENTITY GROUPS",
      "apiLog": "API LOG",
      "overview": "OVERVIEW",
      "entities": "ENTITIES",
      "users": "USERS",
      "cmpCoreVersions": "CMP CORE VERSIONS",
      "monitoring": "MONITORING",
      "operations": "OPERATIONS",
      "activations": "ACTIVATIONS",
      "goalsAdvanced": "REGOLE CUSTOM (ADVANCED)",
      "customImportsAdvanced": "FILE CARICATI (ADVANCED)",
      "destinationsAdmin": "DESTINATIONS (ADMIN)",
      "visionConfigurator": "VISION CONFIGURATOR"
    },
    "filters": {
      "title": "Filtri",
      "reset": "(azzera)",
      "toggleTitle": "Applica i filtri ai grafici principali",
      "toggleSubtitle": "Mantieni allineati i grafici con i filtri correnti",
      "dateRanges": {
        "7days": "Ultimi 7 giorni",
        "14days": "Ultimi 14 giorni",
        "30days": "Ultimi 30 giorni",
        "90days": "Ultimi 90 giorni"
      },
      "device": {
        "label": "Dispositivo ({{selected}}/{{total}})"
      },
      "traffic": {
        "label": "Fonte traffico ({{selected}}/{{total}})"
      },
      "audience": {
        "label": "Audience ({{selected}}/{{total}})",
        "summary": "Min: 2, Max: 5 audience"
      },
      "goal": {
        "label": "Custom Rule",
        "none": "Nessuno"
      },
      "country": {
        "label": "Paese",
        "searchPlaceholder": "Cerca paese...",
        "noResults": "Nessun paese trovato"
      },
      "multiSelection": "Selezione multipla consentita",
      "singleSelection": "Solo selezione singola"
    }
  },
  "changePassword": {
    "title": "Cambia password",
    "oldPassword": "Password attuale",
    "newPassword": "Nuova password",
    "confirmPassword": "Conferma nuova password",
    "cancel": "Annulla",
    "submit": "Aggiorna password",
    "loading": "Salvataggio...",
    "success": "Password aggiornata correttamente.",
    "errors": {
      "allFieldsRequired": "Compila tutti i campi.",
      "passwordMismatch": "Le password non coincidono.",
      "passwordTooShort": "La nuova password deve contenere almeno 8 caratteri.",
      "wrongOldPassword": "La password attuale non è corretta.",
      "samePassword": "La nuova password deve essere diversa da quella attuale.",
      "generic": "Impossibile aggiornare la password. Riprova più tardi.",
      "encryption": "Impossibile cifrare la password. Aggiorna la pagina e riprova.",
      "unauthenticated": "Accedi nuovamente prima di cambiare password."
    }
  },
  "dashboard": {
    "table": {
      "title": "Tabella dati",
      "columns": "Colonne",
      "selectOption": "Seleziona opzione",
      "selectAll": "Seleziona tutto",
      "headers": {
        "audiences": "AUDIENCE",
        "personas": "PERSONAS",
        "sources": "SOURCE",
        "device": "DEVICE",
        "goal": "CUSTOM RULE",
        "goalType": "CUSTOM RULE",
        "users": "UTENTI"
      },
      "options": {
        "source": "Source",
        "device": "Device",
        "goal": "Custom Rules"
      }
    },
    "deviceMetrics": {
      "device": "Device",
      "source": "Source",
      "goal": "Custom rule"
    },
    "charts": {
      "totalUsers": "Utenti totali",
      "enrichedUsers": "Utenti arricchiti",
      "usersByMetric": "Utenti per {{metric}}",
      "publicBreakdown": "Utenti per Audience Insight",
      "personasBreakdown": "Utenti per Personas"
    },
    "tooltips": {
      "totalUsers": "Utenti unici conteggiati nell'intervallo di date selezionato.",
      "enrichedUsers": "Ripartizione tra utenti arricchiti e base aggregata su tutte le fonti abilitate.",
      "usersByDevice": "Quota di utenti per dispositivo/sorgente/obiettivo in base alla metrica scelta nel menu.",
      "publicBreakdown": "Andamento temporale degli utenti suddivisi per le audience selezionate.",
      "personasBreakdown": "Andamento temporale degli utenti suddivisi per le personas selezionate."
    },
    "status": {
      "errorTitle": "Dati non disponibili",
      "errorDescription": "I dati della dashboard non sono attualmente disponibili.",
      "noData": "Nessun dato disponibile per i filtri selezionati.",
      "noDataFilters": "Non sono disponibili dati per questa combinazione di filtri. Prova ad aggiungere o rimuovere alcuni filtri e ripeti."
    }
  },
  "publisherDashboard": {
    "title": "Analytics",
    "subtitle": "Una panoramica dell'attività e dell'arricchimento della tua audience.",
    "timeRange": {
      "label": "Intervallo temporale",
      "days": "{{count}} giorni"
    },
    "providerFilter": {
      "label": "Data provider",
      "all": "Tutti i data provider"
    },
    "stats": {
      "activeUsers": "Utenti attivi",
      "newUsers": "Nuovi utenti",
      "enrichedUsers": "Utenti arricchiti",
      "conversionEvents": "Eventi di conversione di {{count}} utenti",
      "emails": "Utenti con email",
      "maids": "Utenti con MAID"
    },
    "charts": {
      "trends": "Andamento TNCID",
      "goalSeries": "Obiettivo",
      "missingData": "Dati non ancora disponibili",
      "clusters": "Cluster",
      "exportIds": "TNCID con sync verso Terze Parti/Altri ID"
    },
    "sections": {
      "geo": "Dati geografici",
      "ageGender": "Età e genere",
      "providerBreakdown": "Dettaglio data provider",
      "tags": "Tag"
    },
    "ageGender": {
      "total": "Totale",
      "male": "Uomini",
      "female": "Donne"
    },
    "technologies": {
      "browser": "Browser",
      "device": "Dispositivi",
      "os": "Sistemi operativi",
      "other": "Altro"
    },
    "actions": {
      "retry": "Riprova"
    },
    "status": {
      "error": "Si è verificato un errore durante il caricamento dei dati della dashboard.",
      "noData": "Nessun dato disponibile per l'intervallo temporale selezionato."
    },
    "stale": {
      "label": "Dati al {{date}}",
      "tooltip": "Dati non aggiornati: l'ultimo aggiornamento disponibile è del {{date}}, non di ieri."
    }
  },
  "realtime": {
    "title": "Realtime",
    "subtitle": "Eventi ricevuti negli ultimi minuti, aggiornati in diretta.",
    "subtitleGlobal": "Eventi ricevuti negli ultimi minuti su tutte le entity, aggiornati in diretta.",
    "window": {
      "label": "Finestra temporale",
      "minutes": "{{count}} min"
    },
    "live": {
      "pause": "Pausa",
      "resume": "Riprendi diretta"
    },
    "updatedAt": "Aggiornato alle {{time}}",
    "sampling": {
      "title": "Campione dello {{pct}}% degli eventi",
      "detail": "La tabella mostra {{shown}} eventi su {{total}} ricevuti."
    },
    "stats": {
      "total": "Eventi (ultimi {{count}} min)",
      "lastMinute": "Eventi nell'ultimo minuto completo",
      "perSecond": "Eventi al secondo",
      "sampled": "Eventi in elenco"
    },
    "dims": {
      "entity": "Entity",
      "provider": "Data provider",
      "sourceType": "Evento"
    },
    "filters": {
      "label": "Filtri:",
      "minute": "Minuto",
      "clear": "Rimuovi tutti"
    },
    "chart": {
      "title": "Eventi al minuto",
      "total": "Totale",
      "hint": "Clicca una barra per filtrare quel minuto; clicca una riga a destra per scendere nel dettaglio."
    },
    "breakdown": {
      "title": "Per {{dim}}"
    },
    "table": {
      "title": "Eventi",
      "titleSampled": "Eventi campionati",
      "time": "Ora",
      "email": "Email (SHA256)",
      "phone": "Telefono (SHA256)",
      "customVars": "Var. custom",
      "customVarsHint": "{{count}} variabili custom: apri l'evento per vederle",
      "empty": "Nessun evento per i filtri selezionati.",
      "more": "Mostra altri ({{shown}} di {{total}})",
      "truncated": "Elenco limitato agli eventi più recenti."
    },
    "detail": {
      "title": "Dettaglio evento",
      "loading": "Caricamento…",
      "error": "Impossibile caricare l'evento.",
      "notFound": "Evento non trovato.",
      "masked": "Gli identificativi sono mascherati.",
      "unmasked": "Gli identificativi sono mostrati in chiaro.",
      "identifiers": "Identificativi",
      "customVariables": "Variabili custom",
      "fields": "Tutti i campi"
    },
    "labels": {
      "none": "(nessuno)",
      "other": "Altro"
    },
    "actions": {
      "retry": "Riprova",
      "reveal": "Mostra in chiaro",
      "close": "Chiudi"
    },
    "status": {
      "error": "Si è verificato un errore nel caricamento dei dati realtime.",
      "forbidden": "Non hai i permessi per vedere i dati realtime in questo contesto.",
      "noData": "Nessun evento nella finestra selezionata."
    }
  },
  "personas": {
    "treemap": {
      "placeholder": "Audience {{index}}"
    }
  },
  "customImports": {
    "title": "File caricati",
    "subtitle": "Gestisci l'import di dati e monitora lo stato di elaborazione.",
    "actions": {
      "new": "+ Carica file",
      "create": "Crea",
      "import": "Carica file",
      "edit": "Modifica",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "cancel": "Annulla",
      "save": "Salva",
      "saving": "Salvataggio…",
      "close": "Chiudi",
      "menuTitle": "Azioni rapide"
    },
    "filters": {
      "search": "Cerca file",
      "searchPlaceholder": "Cerca file…",
      "status": {
        "label": "Stato",
        "active": "Attivi",
        "inactive": "Inattivi"
      },
      "all": "Tutti",
      "active": "Attivi",
      "inactive": "Inattivi"
    },
    "states": {
      "loading": "Caricamento import…",
      "empty": "Nessun file disponibile."
    },
    "table": {
      "name": "Nome",
      "exportIdType": "Export ID",
      "owner": "Proprietario",
      "createdAt": "Creato",
      "exportIds": "Export ID",
      "tncids": "TNCID associati",
      "status": "Stato",
      "actions": "Azioni"
    },
    "form": {
      "createTitle": "Carica file",
      "editTitle": "Modifica file",
      "description": "Carica un file per creare un’audience di prima parte oppure utilizzarlo come seed per un’audience lookalike",
      "name": "Nome",
      "namePlaceholder": "Inserisci il nome del file",
      "exportIdType": "Tipo ID",
      "fileUpload": "Carica file",
      "fileUploadHint": "Carica un file CSV o TXT con una singola colonna contenente gli ID da importare",
      "file": "File",
      "dropFileHint": "Rilascia il file qui",
      "uploading": "Upload… {{value}}%",
      "storagePath": "Cartella di ingestion",
      "storagePathHint": "Deposita qui nuovi file con lo stesso formato per aggiungerli automaticamente a questo import.",
      "ownerType": "Tipo proprietario",
      "ownerId": "ID proprietario",
      "active": "Attivo",
      "status": "Attiva subito",
      "select": "Seleziona un'opzione",
      "selectIdTypeFirst": "Seleziona prima un tipo di ID"
    },
    "messages": {
      "saved": "File salvato correttamente.",
      "activated": "Import attivato.",
      "deactivated": "Import disattivato."
    },
    "errors": {
      "load": "Impossibile caricare gli import.",
      "save": "Impossibile salvare il file.",
      "status": "Impossibile aggiornare lo stato.",
      "fileRequired": "Seleziona un file da caricare.",
      "preview": "Impossibile visualizzare le colonne del file."
    },
    "pagination": {
      "rowsPerPage": "Righe per pagina",
      "page": "Pagina {{current}} di {{total}}"
    }
  },
  "goals": {
    "title": "Regole Custom",
    "subtitle": "Traccia le azioni degli utenti e le conversioni con regole personalizzate.",
    "actions": {
      "new": "+ Nuova Custom Rule",
      "edit": "Modifica",
      "delete": "Elimina",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "extractionRunning": "Estrazione in corso: la Custom Rule non puo' essere modificata, ricalcolata o eliminata finche' non termina.",
      "recalculate": "Calcola",
      "downloadTrend": "Scarica dati trend",
      "deleteConfirm": "Eliminare la Custom Rule \"{{name}}\"?",
      "recalculateConfirm": "Ricalcolare \"{{name}}\" per gli ultimi 90 giorni?",
      "cancel": "Annulla",
      "save": "Salva",
      "close": "Chiudi",
      "menuTitle": "Azioni rapide",
      "processing": "Elaborazione in corso..."
    },
    "filters": {
      "search": "Cerca regole custom",
      "searchPlaceholder": "Cerca…",
      "status": {
        "label": "Stato",
        "active": "Attivo",
        "inactive": "Inattivo"
      },
      "selected": "Regole custom selezionate",
      "selectedHint": "Scegli una o più regole per filtrare la lista.",
      "statusHint": "Filtra per regole attive o inattive"
    },
    "states": {
      "loading": "Caricamento…",
      "empty": "Nessuna Regola Custom disponibile.",
      "saving": "Salvataggio…",
      "dataPending": "In attesa dei dati: potrebbero volerci alcuni minuti dopo l'estrazione."
    },
    "table": {
      "description": "Nome",
      "type": "Tipo",
      "owner": "Proprietario",
      "status": "Stato",
      "events": "Eventi",
      "trend": "Trend Eventi"
    },
    "form": {
      "createTitle": "Crea Custom Rule",
      "editTitle": "Modifica Custom Rule",
      "description": "Crea una Custom Rule che definisce un segmento di utenti",
      "nameField": "Nome",
      "namePlaceholder": "Inserisci il nome della Custom Rule",
      "type": "Tipo di Custom Rule",
      "rule": "Custom Rule",
      "ruleHint": "Inserisci il pattern o la condizione di match",
      "isRegExp": "Usa regular expression",
      "customVarName": "Nome variabile",
      "customVarValue": "Valore variabile",
      "customVarOperator": "Operatore",
      "addValuePlaceholder": "Inserisci valore...",
      "addRegExpPlaceholder": "Inserisci la regular expression...",
      "isNotEmptyHint": "Verifica solo che la variabile abbia un valore non vuoto: non serve inserire valori.",
      "regexpHint": "Il valore viene usato come regular expression senza escape e il match è case-insensitive. La sintassi è RE2, quella di BigQuery: lookahead, lookbehind e backreference non sono supportati.",
      "compiledRuleLabel": "Regola che verrà salvata:",
      "literalMetacharsWarning": "Il valore contiene caratteri regex che con questo operatore vengono trattati come testo (e quindi escapati). Se volevi scrivere una regular expression, scegli l'operatore \"Matches (RegExp)\".",
      "addValue": "Aggiungi",
      "entityType": "Tipo proprietario",
      "entityTypeHint": "es. Entity, Data Source, ecc.",
      "entityId": "ID proprietario",
      "showInDashboard": "Mostra in dashboard",
      "active": "Attiva subito",
      "select": "Seleziona un'opzione",
      "urlOperator": "Operatore",
      "urlValue": "URL",
      "adsField": "Campo Ads",
      "adsOperator": "Operatore",
      "adsValue": "Valori",
      "adsIsNotEmptyHint": "Verifica solo che il campo abbia un valore non vuoto: non serve inserire valori."
    },
    "messages": {
      "saved": "Custom Rule salvata correttamente.",
      "deleted": "Custom Rule eliminata.",
      "activated": "Custom Rule \"{{name}}\" attivata.",
      "deactivated": "Custom Rule \"{{name}}\" disattivata.",
      "recalculating": "La Custom Rule è in elaborazione..."
    },
    "errors": {
      "load": "Impossibile caricare le Custom Rules.",
      "save": "Impossibile salvare la Custom Rule.",
      "delete": "Impossibile eliminare la Custom Rule.",
      "status": "Impossibile aggiornare lo stato della Custom Rule.",
      "noValues": "Aggiungi almeno un valore.",
      "invalidRegExp": "Regular expression non valida: controlla la sintassi.",
      "re2Lookaround": "Lookahead e lookbehind ((?=, (?!, (?<=, (?<!) non sono supportati da BigQuery: riscrivi la regola senza.",
      "re2Backreference": "Le backreference (\\1, \\k<nome>) non sono supportate da BigQuery: riscrivi la regola senza.",
      "re2AtomicGroup": "I gruppi atomici ((?>…) non sono supportati da BigQuery: usa un gruppo normale.",
      "recalculate": "Impossibile ricalcolare la Custom Rule.",
      "missingSourceGroup": "Configurazione incompleta: l'entity selezionata non ha un Source Group first-party associato. Contatta un amministratore."
    },
    "pagination": {
      "rowsPerPage": "Righe per pagina",
      "page": "Pagina {{current}} di {{total}}"
    },
    "warnings": {
      "extractionStalled": "Estrazione partita ma mai conclusa (anche il flusso notturno): riprova con Recalculate."
    }
  },
  "confronto": {
    "title": "Confronto Personas & Insight",
    "sections": {
      "siteTraffic": "% TRAFFICO DEL SITO",
      "siteTrafficSubtitle": "Percentuale traffico del sito all'interno delle Audience elencate",
      "italianTraffic": "% UTENTI DELLA COUNTRY NELLE AUDIENCE ELENCATE",
      "italianTrafficSubtitle": "Percentuale traffico nazionale all'interno delle Audience elencate"
    },
    "empty": "Nessuna audience selezionata.",
    "tooltip": {
      "type": "Tipo",
      "siteTraffic": "Traffico Sito",
      "population": "Media Popolazione",
      "types": {
        "personas": "Personas",
        "public": "Insight"
      }
    },
    "legend": {
      "public": "Audience Insight",
      "personas": "Audience Personas"
    },
    "controls": {
      "audienceLabel": "Filtra",
      "allInsights": "Tutti gli Insight",
      "allPersonas": "Tutte le Personas",
      "allAudiencesSelected": "Tutte le audience",
      "oneSelected": "1 audience selezionata",
      "nSelected": "{{n}} audience selezionate",
      "reset": "Reset",
      "searchLabel": "Ricerca",
      "searchPlaceholder": "Cerca un'audience...",
      "limitLabel": "Mostra",
      "limitAll": "Tutte",
      "limitSuffix": "audience"
    },
    "noResults": "Nessuna audience corrisponde alla ricerca."
  },
  "login": {
    "claim": "",
    "username": "Username",
    "password": "Password",
    "loginAs": "Accedi come username",
    "button": "Accedi",
    "forgotPassword": "Password dimenticata?",
    "errors": {
      "emptyEmail": "Il campo Email non può essere vuoto",
      "invalidCredentials": "Username o password non validi",
      "googleSignInFailed": "Accesso con Google non riuscito",
      "googleNotAuthorized": "Questo account Google non è associato a nessun utente della piattaforma. Contatta l'amministratore per richiedere l'accesso.",
      "googleUserInactive": "Il tuo account non è attivo. Contatta l'amministratore per riattivarlo.",
      "googlePendingApproval": "Il tuo account è in attesa di approvazione.",
      "googleInvalidCredential": "Accesso con Google non riuscito. Riprova.",
      "pendingApproval": "Il tuo account è in attesa di approvazione."
    },
    "orDivider": "oppure"
  },
  "passwordRecovery": {
    "title": "Recupera password",
    "description": "Inserisci la tua email: ti invieremo le istruzioni per reimpostare la password.",
    "emailPlaceholder": "Email",
    "submit": "Invia istruzioni",
    "submitting": "Invio in corso…",
    "backToLogin": "Torna al login",
    "messages": {
      "emailRequired": "Inserisci l'indirizzo email associato al tuo account.",
      "recaptchaMissing": "Recaptcha non configurato.",
      "success": "Se l'indirizzo è corretto riceverai un'email con le istruzioni per reimpostare la password.",
      "notFound": "Non è stato trovato alcun account associato a questo indirizzo email.",
      "genericError": "Impossibile avviare il recupero password."
    },
    "errors": {
      "unavailableEnv": "Recaptcha non disponibile in questo ambiente.",
      "unavailable": "Recaptcha non disponibile.",
      "token": "Impossibile ottenere il token di verifica recaptcha."
    }
  },
  "passwordReset": {
    "title": "Imposta una nuova password",
    "description": "Scegli la nuova password per il tuo account.",
    "passwordPlaceholder": "Nuova password",
    "confirmPasswordPlaceholder": "Conferma nuova password",
    "submit": "Imposta password",
    "submitting": "Salvataggio...",
    "backToLogin": "Torna al login",
    "messages": {
      "missingToken": "Questo link non e' valido. Richiedi una nuova email di reset password.",
      "allFieldsRequired": "Compila tutti i campi.",
      "passwordMismatch": "Le password non coincidono.",
      "passwordTooShort": "La nuova password deve contenere almeno 8 caratteri.",
      "invalidToken": "Questo link e' scaduto o e' gia' stato usato. Richiedi una nuova email di reset password.",
      "success": "Password aggiornata correttamente. Verrai reindirizzato alla pagina di login.",
      "genericError": "Impossibile impostare la nuova password. Riprova piu' tardi."
    }
  },
  "footer": {
    "copyright": "Copyright ©️{{ year }} Tutti i diritti riservati - The Newco S.r.l. - P.IVA 03670431208 - ",
    "links": {
      "products": "Informativa Privacy Prodotti e Servizi",
      "cookie": "Cookie Policy",
      "website": "Informativa Privacy Sito Web"
    }
  },
  "audiences": {
    "badge": {
      "unmanageable": "Non gestibile",
      "obsoleteFilters": "Filtri obsoleti"
    },
    "title": "Audience",
    "subtitle": "Crea e gestisci le tue audience",
    "table": {
      "status": "Stato",
      "name": "Nome",
      "volume": "Sizes"
    },
    "actions": {
      "create": "+ Crea Audience",
      "preview": "Bozza audience",
      "createDraft": "Crea bozza",
      "save": "Salva",
      "cancel": "Annulla",
      "resetSuggestedPoint": "Reset suggested point",
      "showFullCurve": "Mostra curva completa",
      "back": "Torna alle audience",
      "filter": "Filtri",
      "resetFilters": "Reset filtri",
      "menuTitle": "Azioni rapide",
      "edit": "Modifica audience",
      "clone": "Copia audience",
      "statusUpdated": "Stato audience aggiornato",
      "statusUpdateFailed": "Impossibile aggiornare lo stato dell'audience",
      "processing": "Operazione in corso...",
      "exportStarted": "Elaborazione audience avviata",
      "exportFailed": "Impossibile avviare l'elaborazione",
      "exportTimeout": "L'estrazione di \"{{name}}\" sta richiedendo più tempo del previsto. Aggiorna la pagina per verificare lo stato.",
      "deleted": "Audience eliminata",
      "deleteFailed": "Impossibile eliminare l'audience",
      "overlapLoaded": "Dati di overlap recuperati",
      "overlapFailed": "Impossibile caricare i dati di overlap",
      "pauseUpdate": "Metti in pausa l'aggiornamento",
      "resumeUpdate": "Riprendi l'aggiornamento",
      "export": "Esporta",
      "checkOverlap": "Verifica overlap",
      "delete": "Elimina audience",
      "deleteConfirm": "Vuoi eliminare l'audience \"{{name}}\"?",
      "deleteConfirmTitle": "Conferma eliminazione",
      "deleteConfirmMessage": "Sei sicuro di voler eliminare \"{{name}}\"? L'operazione non è reversibile",
      "exportConfirmTitle": "Esporta audience",
      "exportConfirmMessage": "Vuoi avviare una nuova estrazione per \"{{name}}\"?",
      "confirmExport": "Avvia estrazione",
      "pauseConfirmTitle": "Pausa aggiornamenti",
      "pauseConfirmMessage": "Vuoi mettere in pausa gli aggiornamenti di \"{{name}}\"?",
      "pauseConfirmButton": "Pause",
      "resumeConfirmTitle": "Riprendi aggiornamenti",
      "resumeConfirmMessage": "Vuoi riprendere gli aggiornamenti di \"{{name}}\"?",
      "resumeConfirmButton": "Riprendi",
      "quick": {
        "edit": "Modifica audience",
        "preview": "Bozza audience",
        "approve": "Approva audience",
        "clone": "Copia audience",
        "pause": "Pausa aggiornamenti",
        "resume": "Riprendi aggiornamenti",
        "activate": "Calcola audience",
        "export": "Attiva destinazione",
        "overlap": "Compara audience",
        "delete": "Elimina audience",
        "processing": "Operazione in corso…",
        "reportError": "Segnalalo agli amministratori"
      },
      "curvePendingWarning": "Quick action disponibili quando i dati della curva saranno pronti.",
      "incompatibleFiltersWarning": "Questa audience contiene filtri non supportati da questa interfaccia. I filtri incompatibili non saranno visibili nel form e verranno rimossi al salvataggio.",
      "obsoleteFiltersAlert": "Questa audience contiene filtri non più supportati (<strong>{{filters}}</strong>) e non può essere modificata.",
      "customQueryInfo": "Questa audience utilizza una query SQL personalizzata gestita dall'amministratore. I filtri non sono modificabili da questa interfaccia.",
      "staleItemsWarning": "Alcuni elementi nei filtri non sono più disponibili (mostrati in arancione). Verificali prima di salvare.",
      "close": "Chiudi",
      "reportErrorSent": "Segnalazione inviata agli amministratori",
      "reportErrorFailed": "Impossibile inviare la segnalazione"
    },
    "labels": {
      "unmanageable": "Non gestibile"
    },
    "filterTypes": {
      "__mixed__": "Configurazione mista (regole + interessi)"
    },
    "toolbar": {
      "searchPlaceholder": "Cerca audience",
      "total": "{{count}} audience"
    },
    "listFilters": {
      "status": {
        "title": "Filtra per stato",
        "active": "Attive",
        "draft": "Bozze",
        "paused": "In pausa",
        "pending": "In attesa",
        "error": "Errore",
        "billable": "Fatturabili"
      },
      "owner": {
        "title": "Filtra per proprietario",
        "buttonDefault": "Proprietario",
        "searchPlaceholder": "Cerca proprietario",
        "empty": "Nessun proprietario trovato",
        "clearSelection": "Deseleziona tutti",
        "sortLabel": "Ordina per:",
        "sortByName": "Nome",
        "sortByCount": "N° audience"
      },
      "extractionDate": {
        "title": "Filtra per data di estrazione",
        "buttonDefault": "Data estrazione",
        "clear": "Rimuovi",
        "prevMonth": "Mese precedente",
        "nextMonth": "Mese successivo",
        "hint": "Scegli un giorno tra gli ultimi 31 e i prossimi 31.",
        "kindAll": "Tutte",
        "kindDone": "Estratte",
        "kindPlanned": "Da estrarre",
        "loading": "Caricamento…",
        "error": "Impossibile caricare le estrazioni di questo giorno.",
        "summaryPast": "{{done}} audience estratte",
        "summaryToday": "{{done}} estratte · {{planned}} da estrarre",
        "summaryFuture": "{{planned}} audience previste (stima dalla schedulazione)"
      }
    },
    "list": {
      "empty": "Nessuna audience corrisponde ai filtri attivi.",
      "loading": "Caricamento delle audience…",
      "error": "Impossibile caricare le audience in questo momento."
    },
    "details": {
      "meta": "Frequenza: {{ schedule }}",
      "id": "ID",
      "copy": "Copia",
      "copySuccess": "ID audience copiato",
      "copyError": "Impossibile copiare il valore",
      "createdBy": "Creato da",
      "owner": "Proprietario",
      "volume": "Size",
      "createdAt": "Inizio",
      "endDate": "Fine",
      "lastExtraction": "Ultimo aggiornamento",
      "nextExtraction": "Prossimo aggiornamento",
      "schedule": "Frequenza",
      "empty": "Seleziona un'audience per vedere i dettagli",
      "accuracyPreview": "Anteprima Accuratezza",
      "totalUsers": "Utenti Totali",
      "processingData": "Il sistema sta calcolando i volumi. Ricarica la pagina tra qualche minuto per vedere i valori aggiornati."
    },
    "destinations": {
      "title": "Export attivi",
      "activeTitle": "Export attivi",
      "stoppedTitle": "Export in pausa",
      "showStopped": "Mostra in pausa ({{count}})",
      "hideStopped": "Nascondi in pausa",
      "externalSegmentId": "External Segment ID",
      "copied": "Copiato!",
      "externalIdCopied": "External Segment ID copiato",
      "volume": "Volume",
      "nextPush": "Prossimo export",
      "lastPush": "Ultimo export",
      "statusUnknown": "In attesa",
      "availableTitle": "Attiva un export",
      "entity": "Proprietario",
      "connector": "Connettore",
      "activate": "Attiva",
      "activating": "Attivazione in corso…",
      "activationSuccess": "Destinazione {{name}} attivata",
      "activationError": "Impossibile attivare questa destinazione",
      "activationUnavailable": "Questa destinazione non può essere attivata automaticamente per questa audience",
      "openModal": "Attiva destinazione",
      "modalTitle": "Attiva una destinazione per \"{{name}}\"",
      "modalSubtitle": "Scegli una delle destinazioni disponibili per esportare questa audience.",
      "modalEmpty": "Non ci sono destinazioni dispobili per questa audience.",
      "searchPlaceholder": "Cerca destinazioni",
      "statusActive": "Attiva",
      "statusStopped": "In pausa",
      "pause": "Metti in pausa export",
      "resume": "Riavvia export",
      "edit": "Modifica attivazione",
      "empty": "Nessuna destinazione attiva.",
      "menuTitle": "Azioni attivazione",
      "forcePush": "Forza push",
      "forcePushConfirmTitle": "Forza il push dell'attivazione",
      "forcePushConfirmMessage": "Questa operazione forzerà immediatamente il push di \"{{audienceName}}\" verso \"{{destinationName}}\", al di fuori della normale pianificazione. Sei sicuro di voler continuare?",
      "forcePushConfirmButton": "Forza push",
      "forcePushSuccess": "Push forzato avviato per \"{{name}}\"",
      "forcePushError": "Impossibile forzare il push di questa attivazione",
      "stopConfirmTitle": "Metti in pausa l'attivazione",
      "stopConfirmMessage": "Vuoi anche rimuovere l'audience da \"{{destinationName}}\"? Scegliendo \"Solo pausa\" l'attivazione resta in pausa e potrà essere riavviata in seguito. Rimuoverla disattiva anche il segmento lato destinazione e non potrà essere riavviata da qui.",
      "stopOnlyButton": "Solo pausa",
      "stopAndRemoveButton": "Metti in pausa e rimuovi",
      "removeSuccess": "Attivazione rimossa",
      "removeError": "Impossibile rimuovere questa attivazione",
      "pushTrend": "Trend push",
      "pushTrendHint": "Volumi di push negli ultimi 14 giorni",
      "note": "Nota"
    },
    "overlap": {
      "title": "Overlap audience",
      "source": "Sorgente: {{ name }}",
      "target": "Compara audience",
      "tncids": "TNCiD in comune",
      "sourceShare": "Overlap sorgente",
      "targetShare": "Overlap destinazione",
      "empty": "Esegui l'azione \"Verifica overlap\" per popolare questo elenco.",
      "loading": "Caricamento dati di overlap…",
      "searchPlaceholder": "Cerca audience o proprietario",
      "nameLabel": "Nome",
      "owner": "Proprietario",
      "sortBy": "Ordina per:",
      "resultsCount": "{{ count }} risultati"
    },
    "pagination": {
      "rowsPerPage": "Righe per pagina",
      "page": "Pagina {{current}} di {{total}}"
    },
    "create": {
      "title": "Crea audience",
      "subtitle": "Definisci i criteri di targeting e le altre configurazioni della tua audience",
      "success": "Audience creata con successo",
      "basic": "Dettagli audience",
      "aiSection": "Targeting",
      "aiTip": "Crea audience descrivendo interessi e comportamenti degli utenti",
      "tooltips": {
        "type": "Interessi: Crea audience basate sulle caratteristiche degli utenti, i loro comportamenti e i dati demografici.\nCustom Audience: Crea audience utilizzando dati di prima parte e interazioni con gli utenti.",
        "isPublic": "Se selezionata, l'audience sarà visibile e attivabile da altre entity."
      },
      "types": {
        "interest": "Interessi",
        "rule": "Custom Audience",
        "customquery": "Custom Query"
      },
      "actions": {
        "analysis": "Analizza prompt",
        "addTagTitle": "Aggiungi tag personalizzati",
        "addTag": "Aggiungi tag",
        "removeTag": "Rimuovi tag",
        "selectAllRegions": "Seleziona tutte le regioni"
      },
      "previewSuccess": "Bozza audience creata con successo",
      "previewError": "Impossibile generare la bozza dell'audience.",
      "filters": {
        "title": "Affina con i filtri",
        "age": "Età",
        "ageAll": "Tutte le età",
        "ageUnknown": "Sconosciuta",
        "gender": "Genere",
        "genderAll": "Tutti i generi",
        "genderUnknown": "Sconosciuto",
        "location": "Paese",
        "locationAll": "Tutte i paesi",
        "locationReset": "Reset paese",
        "regionAll": "Tutte le regioni"
      },
      "similarUsers": {
        "sectionTitle": "Espansione",
        "label": "Espandi l'audience con utenti simili",
        "yes": "Sì",
        "no": "No"
      },
      "expandVersion": {
        "label": "Modalità espansione (admin)",
        "standard": "Standard",
        "weighted": "Pesata (IDF)",
        "curveUnavailable": "Curva non ancora disponibile per questa modalità: verrà calcolata alla prossima estrazione dopo il salvataggio."
      },
      "lookalikeMethod": {
        "label": "Metodo lookalike (admin)",
        "knn": "KNN (predefinito)",
        "centered-knn": "KNN centrata",
        "centroid": "Centroide",
        "centered-centroid": "Centroide centrato"
      },
      "rule": {
        "sectionTitle": "Targeting",
        "sectionSubtitle": "Combina i dati di prima parte con altre audience e crea lookalike.",
        "groupsTitle": "Gruppo di regole",
        "actions": {
          "custom_import": "Imported Data",
          "goal": "Custom Rule",
          "audience": "Audience",
          "source": "Data Source"
        },
        "groupName": "Nome gruppo",
        "groupNamePlaceholder": "es. High intent shoppers",
        "customField": "I valori selezionati sono combinati usando una condizione OR.",
        "customPlaceholder": "Inserisci un percorso o un bucket",
        "selectCustomImport": "Seleziona file",
        "goalField": "Custom Rule",
        "selectGoal": "Seleziona Custom Rule",
        "audienceField": "Audience esistente",
        "selectAudience": "Seleziona un'audience",
        "sourceField": "Tipo sorgente",
        "selectSource": "Seleziona una sorgente",
        "searchPlaceholder": "Cerca…",
        "remove": "Rimuovi",
        "removeBlock": "Rimuovi gruppo di regole",
        "addBlock": "Aggiungi gruppo di regole",
        "groupOperator": "Operatore tra gruppi",
        "operator": {
          "and": "AND",
          "or": "OR",
          "not": "NOT",
          "and_not": "AND NOT"
        },
        "preview": {
          "title": "Anteprima regole",
          "block": "Gruppo di regole {{index}}",
          "connector": "E",
          "itemConnector": "OPPURE",
          "empty": "Aggiungi almeno una regola per vedere l'anteprima."
        },
        "staleItemsWarning": "⚠ Elementi non più disponibili — rimuovili prima di salvare:",
        "removeStaleItem": "Rimuovi elemento non disponibile"
      },
      "accuracy": {
        "high": "Alta",
        "medium": "Media",
        "low": "Bassa",
        "description": {
          "high": "Massima precisione, dimensioni audience limitate",
          "medium": "Bilanciamento tra precisione e dimensioni",
          "low": "Massima portata, minore precisione"
        }
      },
      "fields": {
        "type": "Tipo di audience",
        "name": "Nome",
        "description": "Descrizione",
        "frequency": "Frequenza",
        "startDate": "Prossimo aggiornamento",
        "endDate": "Fine aggiornamento",
        "ongoing": "Aggiornamento continuo",
        "aiPrompt": "Brief",
        "useAllNetworkData": "Fonte dei tag",
        "accuracy": "Accuratezza",
        "accuracyDescription": "Indica il numero preciso di utenti da includere nell'audience, oppure seleziona il livello di accuratezza desiderato ottimizzato dall'AI",
        "audienceSize": "Dimensione dell'audience",
        "audienceSizeHint": "Inserisci il numero esatto di utenti desiderati. Lascia vuoto per usare l'accuratezza.",
        "expandSimilar": "Espandi l'audience con utenti simili",
        "region": "Regioni",
        "regionPlaceholder": "Seleziona le regioni",
        "regionDisabled": "Seleziona prima un paese",
        "regionCount": "{{count}} Regioni selezionate",
        "regionEmpty": "Nessuna regione disponibile",
        "isPublic": "Audience pubblica"
      },
      "dataSources": {
        "network": "TNC Network",
        "firstParty": "Dati di prima parte",
        "networkOnly": "La sorgente dati per questa audience sarà tutto il network TNC."
      },
      "scheduleTitle": "Programma update",
      "preview": {
        "accuracyDescription": "Controlla la curva incrementale dell'audience, scegli il livello di precisione desiderato e poi conferma lo scheduling.",
        "selectedRange": "Range distanza: {{range}}",
        "selectedUsers": "{{users}} utenti",
        "distanceRange": "Distanza",
        "users": "utenti",
        "pendingGraphTitle": "Il grafico non e' ancora disponibile",
        "pendingGraphMessage": "Abbiamo gia' provato a recuperare i dati del grafico, ma non sono ancora pronti. Attendi un paio di minuti e aggiorna la pagina per vedere i valori aggiornati.",
        "filtersChangedTitle": "Il grafico non e' piu' disponibile",
        "filtersChangedMessage": "Hai modificato i filtri che determinano la curva di accuratezza. La curva verra' ricalcolata dopo il salvataggio. Ripristina i filtri iniziali per rivedere il grafico attuale."
      },
      "placeholders": {
        "name": "Nuova Audience",
        "description": "Questa audience è",
        "aiPrompt": "Utenti interessati al calcio e allo shopping",
        "tag": "Tag personalizzato",
        "location": "Cerca un paese",
        "audienceSize": "Es: 10000"
      },
      "summary": {
        "title": "Overview",
        "audienceType": "Tipo di audience",
        "name": "Nome",
        "startDate": "Prossimo aggiornamento",
        "frequency": "Frequenza",
        "accuracy": "Accuratezza",
        "volumes": "Volumi",
        "suggestedVolumes": "Volumi suggeriti",
        "notExtracted": "Non ancora estratta",
        "age": "Età",
        "gender": "Genere",
        "location": "Località",
        "conditions": "Condizioni della regola",
        "conditionsEmpty": "Aggiungi almeno una condizione per vedere il riepilogo.",
        "previewPending": "Bozza richiesta"
      },
      "noInterestsConfirm": {
        "title": "Sei sicuro di voler creare un'audience senza filtri sugli interessi?",
        "confirm": "Sì",
        "cancel": "Annulla"
      },
      "leaveConfirm": {
        "title": "Sei sicuro di voler abbandonare la creazione dell'audience?",
        "confirm": "Si",
        "cancel": "Annulla"
      },
      "remoteChange": {
        "titleUpdated": "Audience modificata",
        "bodyUpdated": "Questa audience è stata modificata da un altro utente. Clicca Annulla per uscire e visualizzare la versione aggiornata.",
        "titleDeleted": "Audience eliminata",
        "bodyDeleted": "Questa audience è stata eliminata da un altro utente. Clicca Annulla per uscire."
      },
      "errorMissingPayload": "Dati insufficienti per creare l'audience.",
      "errorGeneric": "Creazione dell'audience non riuscita, riprova più tardi.",
      "errors": {
        "tagsRequired": "Aggiungi almeno un tag per l'audience basata su interessi",
        "ruleFilterRequired": "Aggiungi almeno un filtro (Audience, Custom Rule, Imported Data o Source) per l'audience Custom",
        "interestFilterRequired": "Senza interessi seleziona almeno un paese o un genere.",
        "previewRequired": "Genera prima la bozza audience e poi salva.",
        "missingFirstPartyGroup": "Configurazione incompleta: il gruppo dati first-party per il provider \"{{provider}}\" non è stato trovato. Contatta un amministratore per completare la configurazione.",
        "missingGoalSourceGroup": "Configurazione incompleta: il goal \"{{goal}}\" non ha un Source Group associato. Contatta un amministratore per completare la configurazione."
      }
    },
    "trend": {
      "noData": "Nessun dato di estrazione disponibile.",
      "series": {
        "existing": "Esistenti",
        "new": "Nuovi",
        "removed": "Rimossi"
      }
    },
    "extractions": {
      "title": "Estrazioni audience",
      "subtitle": "Audience estratte per giorno (ultimi 31 giorni) e programmate in avanti",
      "advanced": "Avanzato",
      "advancedHint": "Visibile solo con il permesso admin dashboard",
      "error": "Impossibile caricare le estrazioni.",
      "perDay": "/giorno",
      "peak": "picco",
      "scheduledDays": "giorni programmati",
      "today": "oggi",
      "legendExtracted": "Estratte",
      "legendScheduled": "Programmate",
      "experimental": "Sperimentale",
      "experimentalHint": "Funzione sperimentale — attivala dal pannello Experimental Features"
    },
    "volumes": {
      "title": "Volumi",
      "error": "Impossibile caricare i volumi.",
      "empty": "Nessun dato di volume disponibile.",
      "showMore": "Mostra altri",
      "showLess": "Mostra meno"
    },
    "additionalInfo": {
      "title": "Info aggiuntive",
      "tabs": {
        "details": "Dettagli",
        "volumes": "Volumi",
        "sociodemo": "Sociodemo",
        "tags": "Tag",
        "changelog": "Changelog"
      },
      "details": {
        "info": "Info audience",
        "status": "Stato",
        "schedule": "Schedulazione",
        "volume": "Volume",
        "owner": "Owner",
        "description": "Descrizione",
        "quality": "Indice qualità",
        "timerange": "Timerange globale",
        "expand": "Espandi utenti simili",
        "dates": "Date",
        "created": "Creata",
        "lastExtraction": "Ultima estrazione",
        "nextExtraction": "Prossima estrazione",
        "endDate": "Data fine",
        "id": "ID audience",
        "copyId": "Copia ID",
        "copied": "Copiato",
        "filters": "Filtri",
        "tags": "Tag",
        "costs": {
          "title": "Analisi costi",
          "load": "Carica analisi costi",
          "loading": "Caricamento…",
          "error": "Impossibile caricare l'analisi dei costi.",
          "lastExtraction": "Costo ultima estrazione",
          "avgExecution": "Costo medio esecuzione",
          "totalCost": "Costo totale"
        }
      },
      "sociodemo": {
        "error": "Impossibile caricare il sociodemo.",
        "empty": "Nessun dato sociodemo disponibile.",
        "male": "Uomini",
        "female": "Donne",
        "total": "Totale",
        "ageBreakdown": "Distribuzione per età",
        "noAges": "Nessuna distribuzione per età disponibile."
      },
      "tags": {
        "error": "Impossibile caricare i tag.",
        "empty": "Nessun dato sui tag disponibile.",
        "targetSize": "Dimensione target",
        "noTags": "Nessun tag."
      },
      "changelog": {
        "error": "Impossibile caricare il changelog.",
        "empty": "Nessuna modifica registrata."
      }
    }
  },
  "validation": {
    "required": "Questo campo è obbligatorio",
    "invalid": "Questo campo non è valido",
    "min": "Il valore minimo è {{ min }}",
    "max": "Il valore massimo è {{ max }}",
    "audienceQualityRequired": "Seleziona un livello di accuratezza (High, Medium, Low) o specifica la dimensione dell'audience"
  },
  "documentation": {
    "versionBanner": "<strong>TNC Engine versione 0.8</strong> in sviluppo - Contattaci per bug e suggerimenti"
  },
  "errors": {
    "maintenance": "La piattaforma è momentaneamente in manutenzione. Ci scusiamo per il disagio.",
    "sandboxEntity": "Operazione non disponibile: l'oggetto appartiene a un'entity sandbox."
  },
  "trackingScripts": {
    "title": "Tracking Scripts",
    "subtitle": "Gestisci le configurazioni JS client-side e le distribuisci per ogni provider.",
    "actions": {
      "new": "Nuova configurazione",
      "edit": "Modifica",
      "delete": "Elimina",
      "deploy": "Deploy",
      "deploying": "Deploy in corso...",
      "deleteConfirm": "Sei sicuro di voler eliminare \"{{name}}\"?",
      "deleteConfirmGcs": "Attenzione: eliminando questa configurazione, i seguenti file su GCS verranno eliminati permanentemente:\n\n{{files}}\n\nVuoi continuare?",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "activateConfirm": "Attivando \"{{name}}\" verrà eseguito un deploy automatico per applicare la nuova configurazione. Vuoi continuare?",
      "deactivateConfirm": "Attenzione: disattivando \"{{name}}\" verrà eseguito un deploy automatico e il tracking sui siti dei clienti si fermerà immediatamente. Vuoi continuare?",
      "save": "Salva",
      "cancel": "Annulla"
    },
    "fields": {
      "name": "Nome",
      "publisherId": "Entity",
      "publisherIdPlaceholder": "Seleziona un'entity",
      "template": "Template snippet",
      "scripts": "ID sync con terze parti",
      "autostart": "Autostart",
      "tcf": "TCF",
      "publisher": "Publisher",
      "exclude": "Escludi",
      "fontsVersion": "Versione fonts",
      "fontsVersionDefault": "predefinita",
      "modules": "Moduli",
      "callbackScript": "Callback script (JS)",
      "prepareScript": "Prepare script (JS)",
      "overwriteScript": "Overwrite (JS)",
      "snippetAppend": "Codice aggiuntivo snippet (JS)",
      "status": "Stato",
      "statusActive": "Attivo",
      "statusInactive": "Inattivo",
      "providers": "Provider associati"
    },
    "providers": {
      "alreadyInUse": "Già associato ad un'altra configurazione",
      "publisherAlreadyInUse": "Il Publisher ID è già associato ad un'altra configurazione"
    },
    "filters": {
      "search": "Cerca",
      "searchPlaceholder": "Cerca per nome...",
      "type": "Tipologia"
    },
    "table": {
      "name": "Nome",
      "publisherId": "Publisher ID",
      "scripts": "Script",
      "providers": "Provider",
      "status": "Stato",
      "actions": "Azioni"
    },
    "deploy": {
      "success": "Deploy completato per {{count}} provider",
      "partialError": "Deploy completato con {{errors}} errori",
      "error": "Errore durante il deploy",
      "statusPending": "In attesa di deploy",
      "statusDeployed": "Distribuito",
      "statusError": "Errore nel deploy"
    },
    "purge": {
      "action": "Refresh CDN",
      "inProgress": "Refresh CDN in corso...",
      "success": "Cache CDN invalidata per {{count}} path",
      "partialError": "Cache CDN invalidata con {{errors}} errori",
      "error": "Errore durante il refresh CDN",
      "skipped": "CDN non configurata (ambiente di sviluppo)"
    },
    "messages": {
      "created": "Configurazione creata con successo",
      "updated": "Configurazione aggiornata con successo",
      "deleted": "Configurazione eliminata con successo",
      "statusUpdated": "Configurazione attivata e deploy completato",
      "statusDeactivated": "Configurazione disattivata: il tracking sui siti dei clienti è stato fermato",
      "newProviderWillBeCreated": "Verrà creato un nuovo provider associato all'ID selezionato",
      "confirmGcsDeleteWarning": "Attenzione: i seguenti provider sono stati rimossi dalla configurazione e i loro file su GCS verranno eliminati permanentemente:\n\n{{files}}\n\nVuoi continuare con il salvataggio?"
    },
    "errors": {
      "load": "Errore nel caricamento delle configurazioni",
      "save": "Errore nel salvataggio della configurazione",
      "delete": "Errore nell'eliminazione della configurazione",
      "deploy": "Errore durante il deploy",
      "statusUpdate": "Errore durante l'aggiornamento dello stato"
    },
    "empty": "Nessuna configurazione trovata",
    "advanced": {
      "show": "Configurazioni avanzate",
      "hide": "Nascondi configurazioni avanzate"
    },
    "form": {
      "titleCreate": "Nuova configurazione",
      "titleEdit": "Modifica configurazione"
    },
    "snippet": {
      "title": "Script di integrazione",
      "download": "Scarica",
      "copyClipboard": "Copia negli appunti",
      "copied": "Copiato!",
      "viewConfigJs": "Visualizza config.js",
      "notDeployed": "config.js non ancora deployato"
    }
  },
  "reports": {
    "title": "Configurazioni per i report",
    "subtitle": "Gestisci le configurazioni dei report personalizzati per l'entity selezionata.",
    "dashboardTitle": "Reports",
    "dashboardSubtitle": "Controlla guadagni e spese della entity selezionata.",
    "provider": {
      "title": "Report Data Provider",
      "subtitle": "Guadagni generati dalla condivisione di audience.",
      "summary": {
        "audienceTotal": "Attivazioni audience",
        "total": "TOTALE"
      }
    },
    "consumer": {
      "title": "Report Consumer",
      "subtitle": "Spese per l'utilizzo delle audience.",
      "summary": {
        "audienceTotal": "Attivazioni audience",
        "draftTotal": "Draft eseguiti",
        "audienceIncluded": "incluse nel piano",
        "draftIncluded": "inclusi nel piano",
        "total": "TOTALE"
      }
    },
    "actions": {
      "newConfig": "Nuova configurazione",
      "edit": "Modifica",
      "delete": "Elimina",
      "deleteConfirm": "Sei sicuro di voler eliminare \"{{name}}\"?",
      "deleteConfirmTitle": "Conferma eliminazione",
      "deleteConfirmMessage": "Sei sicuro di voler eliminare la configurazione per \"{{name}}\"? L'operazione è irreversibile.",
      "save": "Salva",
      "cancel": "Annulla",
      "menuTitle": "Azioni"
    },
    "filters": {
      "search": "Cerca",
      "searchPlaceholder": "Cerca per nome...",
      "month": "Mese",
      "monthOptions": {
        "all": "Tutti i mesi"
      },
      "year": "Anno",
      "yearOptions": {
        "all": "Tutti gli anni"
      },
      "type": "Tipologia report",
      "typeOptions": {
        "all": "Tutti"
      }
    },
    "entity": {
      "summary": {
        "totalAmount": "Totale del periodo",
        "totalAmountHint": "Guadagni per i data provider e spese per i consumer sulla entity selezionata.",
        "quantity": "Quantità riportata",
        "quantityHint": "Quantità totale restituita per le righe selezionate."
      },
      "table": {
        "date": "Data",
        "kind": "Direzione",
        "details": "Dettagli",
        "description": "Descrizione",
        "quantity": "Quantità",
        "amount": "Importo"
      },
      "direction": {
        "earned": "Guadagno",
        "spent": "Spesa"
      },
      "metrics": {
        "entryType": "Tipo voce",
        "quantity": "Quantità",
        "counterparty": "Entity consumer"
      },
      "emptyPeriod": "Report assenti per il periodo selezionato.",
      "empty": {
        "type": "Nessuna riga report disponibile per {{type}}."
      }
    },
    "table": {
      "entity": "Entity",
      "details": "Dettagli configurazione",
      "createdAt": "Creato il",
      "updatedAt": "Aggiornato il"
    },
    "form": {
      "titleCreate": "Nuova configurazione Report",
      "titleEdit": "Modifica configurazione Report",
      "fields": {
        "type": "Tipologia",
        "entity": "Entity",
        "status": "Stato",
        "revenueShare": "Revenue share",
        "planIncludedAudiences": "Audience incluse",
        "planIncludedDrafts": "Draft inclusi",
        "pricePerAudience": "Prezzo per audience",
        "pricePerDraft": "Prezzo per draft"
      },
      "types": {
        "dataProvider": "Data Provider",
        "consumer": "Consumer"
      },
      "sections": {
        "dataProvider": "Configurazione Data Provider",
        "consumer": "Configurazione Consumer"
      },
      "validation": {
        "entityRequired": "Serve una entity selezionata",
        "revenueShareInvalid": "La revenue share deve essere compresa tra 0 e 100",
        "planIncludedAudiencesRequired": "Le audience incluse devono essere >= 0",
        "planIncludedDraftsRequired": "I draft inclusi devono essere >= 0",
        "pricePerAudienceRequired": "Il prezzo per audience deve essere >= 0",
        "pricePerDraftRequired": "Il prezzo per draft deve essere >= 0"
      }
    },
    "messages": {
      "created": "Configurazione creata con successo",
      "updated": "Configurazione aggiornata con successo",
      "deleted": "Configurazione eliminata con successo",
      "customRowCreated": "Riga custom consumer creata con successo"
    },
    "errors": {
      "load": "Errore nel caricamento delle configurazioni",
      "save": "Errore nel salvataggio della configurazione",
      "delete": "Errore nell'eliminazione della configurazione",
      "customRowSave": "Errore nel salvataggio della riga custom consumer",
      "customRowInvalid": "Compila almeno la data della riga custom consumer"
    },
    "consumerCustomRow": {
      "title": "Aggiungi riga custom",
      "editTitle": "Modifica riga custom",
      "subtitle": "Inserisci una voce manuale per il consumer selezionato.",
      "add": "Aggiungi riga custom",
      "addButton": "Aggiungi riga",
      "save": "Salva",
      "fields": {
        "reportDate": "Data report",
        "entryAmount": "Quantità",
        "entryCost": "Importo",
        "entryDescription": "Descrizione"
      }
    },
    "providerCustomRow": {
      "title": "Aggiungi riga custom",
      "editTitle": "Modifica riga custom",
      "save": "Salva",
      "fields": {
        "reportDate": "Data report",
        "earnings": "Importo",
        "entryDescription": "Descrizione"
      }
    },
    "customRow": {
      "deleteConfirmTitle": "Conferma eliminazione",
      "deleteConfirmMessage": "Sei sicuro di voler eliminare la riga custom \"{{name}}\"? L'operazione è irreversibile."
    },
    "entryTypes": {
      "activation": "Attivazione",
      "audience": "Attivazioni audience",
      "custom": "Custom",
      "audience_included": "Audience incluse nel piano",
      "audience_extra": "Audience extra",
      "draft_included": "Draft inclusi nel piano",
      "draft_extra": "Draft extra"
    },
    "empty": "Nessuna configurazione trovata"
  },
  "cmp": {
    "title": "CMP",
    "subtitle": "Configura la Consent Management Platform (TCF 2.3) per ogni provider.",
    "actions": {
      "new": "Nuova configurazione",
      "edit": "Modifica",
      "delete": "Elimina",
      "deploy": "Deploy",
      "deploying": "Deploy in corso...",
      "confirmDelete": "Eliminare la configurazione \"{{name}}\"?",
      "confirmDeleteGcs": "Attenzione: i seguenti file cmp.js verranno rimossi dal CDN:\n\n{{files}}\n\nConfermi l'eliminazione?"
    },
    "purge": {
      "action": "Refresh CDN",
      "inProgress": "Refresh CDN in corso...",
      "success": "Cache CDN invalidata per {{count}} path",
      "partialError": "Cache CDN invalidata con {{errors}} errori",
      "error": "Errore durante il refresh CDN",
      "skipped": "CDN non configurata (ambiente di sviluppo)"
    },
    "filters": {
      "search": "Cerca",
      "searchPlaceholder": "Cerca per nome..."
    },
    "table": {
      "name": "Nome",
      "language": "Lingua / GVL",
      "vendors": "Vendor",
      "providers": "Provider",
      "status": "Stato"
    },
    "fields": {
      "statusActive": "Attivo",
      "statusInactive": "Inattivo"
    },
    "form": {
      "titleCreate": "Nuova configurazione CMP",
      "titleEdit": "Modifica configurazione CMP",
      "name": "Nome",
      "namePlaceholder": "Es. CMP principale",
      "publisherId": "Entity",
      "publisherIdPlaceholder": "Seleziona un'entity",
      "consentLanguage": "Lingua del consenso",
      "publisherCC": "Country code publisher",
      "cmpId": "CMP ID (IAB)",
      "cmpVersion": "Versione CMP (IAB)",
      "cmpVersionHint": "Derivata automaticamente dalla versione major del core selezionato",
      "vendorListVersion": "Versione GVL",
      "privacyPolicyUrl": "URL Privacy Policy",
      "coreVersion": "Versione CMP core",
      "coreVersionCurrent": "aggiornato",
      "coreVersionOutdated": "È disponibile la v{{current}} — selezionala per aggiornare. Sarà necessario un nuovo deploy.",
      "coreVersionMajorBump": "Breaking change: considera di aggiornare anche CmpVersion (IAB) alla v{{major}}.",
      "autoShow": "Mostra banner automaticamente",
      "autoShowOn": "Sì — mostra banner al primo accesso",
      "autoShowOff": "No — non mostrare automaticamente",
      "purposes": "Finalità IAB (TCF 2.3)",
      "purposeLabel": "Finalità",
      "legalBasisConsent": "Base giuridica: Consenso",
      "legalBasisLI": "Base giuridica: Legittimo Interesse",
      "vendors": "Vendor",
      "vendorsSelected": "selezionati",
      "vendorSearchPlaceholder": "Cerca vendor per nome o ID...",
      "vendorNoResults": "Nessun vendor trovato",
      "selectAll": "Seleziona tutti",
      "deselectAll": "Deseleziona tutti",
      "allVendorsSelected": "Tutti i vendor selezionati",
      "status": "Stato",
      "providers": "Provider",
      "publisherProvider": "Publisher (questa entity)",
      "noProviders": "Nessun provider disponibile",
      "removeDeployedProviderConfirm": "Il provider \"{{id}}\" ha già un cmp.js deployato. Rimuovendolo dalla configurazione il file non sarà più aggiornato al prossimo deploy. Continuare?",
      "advanced": "Impostazioni avanzate",
      "cookieName": "Nome cookie",
      "cookieExpireDays": "Durata cookie (giorni)",
      "i18n": "Override testi UI (i18n)",
      "onConsentSaved": "Callback onConsentSaved"
    },
    "notifications": {
      "created": "Configurazione CMP creata con successo",
      "updated": "Configurazione CMP aggiornata con successo",
      "deleted": "Configurazione CMP eliminata con successo",
      "deployed": "Deploy completato per {{count}} provider",
      "deployPartial": "Deploy completato: {{ok}} OK, {{err}} errori"
    },
    "errors": {
      "loadFailed": "Errore nel caricamento delle configurazioni",
      "saveFailed": "Errore nel salvataggio della configurazione",
      "deleteFailed": "Errore nell'eliminazione della configurazione",
      "deployFailed": "Errore durante il deploy"
    },
    "empty": "Nessuna configurazione CMP trovata",
    "outdated": {
      "tooltip": "Versione CMP non aggiornata — si consiglia un nuovo deploy"
    },
    "snippet": {
      "title": "Snippet di implementazione CMP",
      "hint": "Incolla questo tag <script> nel <head> del sito del cliente, prima di altri script di tracking.",
      "badgeTooltip": "Clicca per vedere lo snippet di implementazione",
      "viewCmpJs": "Visualizza cmp.js",
      "notDeployed": "cmp.js non ancora deployato — esegui prima il deploy",
      "download": "Scarica snippet",
      "copyClipboard": "Copia negli appunti",
      "copied": "Copiato!"
    }
  },
  "notifications": {
    "title": "Notifiche",
    "unread": "non lette",
    "empty": "Nessuna notifica",
    "markAsRead": "Segna come letta",
    "seeAll": "Vedi tutte le notifiche",
    "newNotification": "Nuova notifica",
    "pageSubtitle": "Lo storico delle tue notifiche.",
    "scopeNotice": "Stai vedendo solo le tue notifiche personali e quelle dell'entità attualmente selezionata.",
    "tabs": {
      "personal": "Notifiche personali",
      "admin": "Notifiche admin",
      "entity": "Notifiche dell'entity corrente",
      "entityAll": "Notifiche di tutte le entity"
    },
    "searchPlaceholder": "Cerca nelle notifiche…",
    "noResults": "Nessuna notifica corrisponde ai filtri",
    "loading": "Caricamento…",
    "loadingMore": "Carico altre…",
    "markAllAsRead": "Segna tutte come lette",
    "markAsUnread": "Segna come non letta",
    "markSelectedAsRead": "Segna come lette",
    "markSelectedAsUnread": "Segna come non lette",
    "selectAll": "Seleziona tutte",
    "selectedCount": "{{count}} selezionate",
    "clearSelection": "Annulla",
    "selectRow": "Seleziona notifica",
    "readFilters": {
      "all": "Tutte",
      "unread": "Non lette",
      "read": "Lette"
    },
    "filters": {
      "all": "Tutte",
      "info": "Info",
      "success": "Successo",
      "warning": "Avviso",
      "error": "Errore"
    }
  },
  "visionConfig": {
    "title": "Vision Config",
    "subtitle": "Gestisci l'accesso dei publisher a Vision e configura i column mapping.",
    "tabs": {
      "publishers": "Publisher",
      "mapping": "Column Mapping"
    },
    "filters": {
      "searchPlaceholder": "Cerca publisher…"
    },
    "publishers": "publisher",
    "errors": {
      "loadFailed": "Errore nel caricamento dei dati"
    },
    "table": {
      "publisher": "Publisher",
      "dcrId": "DCR ID",
      "status": "Stato",
      "visionAccess": "Accesso Vision",
      "columnName": "Colonna",
      "objectType": "Tipo",
      "objectName": "Nome Oggetto",
      "objectId": "ID Oggetto"
    },
    "actions": {
      "configureMapping": "Configura Mapping",
      "newMapping": "Nuovo Mapping"
    },
    "mapping": {
      "selectHint": "Seleziona un publisher dalla tab Publisher per gestire i suoi column mapping.",
      "empty": "Nessun mapping configurato per questo publisher."
    },
    "form": {
      "titleNewMapping": "Nuovo Column Mapping",
      "titleEditMapping": "Modifica Column Mapping",
      "columnName": "Nome colonna",
      "objectType": "Tipo oggetto",
      "objectId": "Oggetto",
      "objectIdSelect": "— seleziona —",
      "objectIdPlaceholder": "ID opzionale",
      "objectName": "Nome oggetto",
      "objectNamePlaceholder": "Nome visualizzato"
    }
  },
  "visionConfigurator": {
    "title": "Configuratore Vision",
    "subtitle": "Crea e configura le istanze DCR: column mapping, variabili custom e utenti.",
    "tabs": {
      "instances": "Istanze DCR",
      "configurator": "Configuratore"
    },
    "configTabs": {
      "mapping": "Column Mapping",
      "variables": "Variabili Custom",
      "users": "Utenti"
    },
    "configurator": {
      "selectHint": "Seleziona un'istanza DCR dalla tab Istanze per aprire il configuratore."
    },
    "instances": {
      "search": "Cerca istanze…",
      "createNew": "Nuovo DCR",
      "empty": "Nessuna istanza DCR trovata. Crea la prima.",
      "table": {
        "id": "#",
        "name": "Nome"
      },
      "actions": {
        "configure": "Configura",
        "delete": "Elimina"
      },
      "errors": {
        "loadFailed": "Errore nel caricamento delle istanze DCR",
        "createFailed": "Errore nella creazione dell'istanza DCR",
        "deleteFailed": "Errore nell'eliminazione dell'istanza DCR"
      },
      "form": {
        "title": "Nuova Istanza DCR",
        "name": "Nome",
        "namePlaceholder": "es. My Publisher Vision",
        "note": "Verrà generato automaticamente un UUID univoco per questo DCR. Le tabelle dinamiche (raw_data, agg_data, column_mapping) saranno create dal backend."
      }
    },
    "variables": {
      "empty": "Nessuna variabile custom definita per questo DCR.",
      "actions": {
        "new": "Nuova Variabile"
      },
      "errors": {
        "loadFailed": "Errore nel caricamento delle variabili"
      },
      "table": {
        "name": "Nome",
        "type": "Tipo",
        "value": "Valore"
      },
      "form": {
        "titleNew": "Nuova Variabile Custom",
        "titleEdit": "Modifica Variabile Custom",
        "name": "Nome variabile",
        "type": "Tipo",
        "value": "Valore"
      }
    },
    "users": {
      "empty": "Nessun utente configurato per questo DCR.",
      "searchPlaceholder": "Cerca utenti…",
      "actions": {
        "new": "Nuovo Utente"
      },
      "errors": {
        "loadFailed": "Errore nel caricamento degli utenti"
      },
      "roles": {
        "admin": "Admin",
        "user": "Utente"
      },
      "table": {
        "name": "Nome",
        "email": "Email",
        "role": "Ruolo",
        "status": "Stato"
      },
      "form": {
        "titleNew": "Nuovo Utente",
        "titleEdit": "Modifica Utente",
        "name": "Nome completo",
        "email": "Email",
        "password": "Password",
        "status": "Stato",
        "isAdmin": "Amministratore"
      }
    }
  },
  "versionUpdate": {
    "message": "È disponibile una nuova versione dell'app.",
    "reload": "Ricarica"
  }
}
